/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/layouts/root'
import { Route as routesLayoutsAppRouteImport } from './routes/layouts/app'
import { Route as routesLayoutsAuthRouteImport } from './routes/layouts/auth'
import { Route as routesLayoutsPublicRouteImport } from './routes/layouts/public'
import { Route as routesLayoutsWorkspaceRouteImport } from './routes/layouts/workspace'
import { Route as screensOnboardingWelcomeScreenRouteImport } from './screens/onboarding/WelcomeScreen'
import { Route as screensAppHomeScreenRouteImport } from './screens/app/HomeScreen'
import { Route as screensAppAlertsScreenRouteImport } from './screens/app/AlertsScreen'
import { Route as screensBasketsBasketsScreenRouteImport } from './screens/baskets/BasketsScreen'
import { Route as screensBrokersOverviewScreenRouteImport } from './screens/brokers/OverviewScreen'
import { Route as screensAppChatScreenRouteImport } from './screens/app/ChatScreen'
import { Route as screensAppCompaniesScreenRouteImport } from './screens/app/CompaniesScreen'
import { Route as screensCoursesCoursesScreenRouteImport } from './screens/courses/CoursesScreen'
import { Route as screensDashboardsDashboardsScreenRouteImport } from './screens/dashboards/DashboardsScreen'
import { Route as screensIpoIssuesRedirectRouteImport } from './screens/ipo/IssuesRedirect'
import { Route as screensMarketOverviewScreenRouteImport } from './screens/market/OverviewScreen'
import { Route as screensMutualFundsAnalyticsScreenRouteImport } from './screens/mutual-funds/AnalyticsScreen'
import { Route as screensNewsletterNewslettersRedirectRouteImport } from './screens/newsletter/NewslettersRedirect'
import { Route as screensAppNotificationsScreenRouteImport } from './screens/app/NotificationsScreen'
import { Route as screensPortfolioOverviewScreenRouteImport } from './screens/portfolio/OverviewScreen'
import { Route as screensAccountProfileScreenRouteImport } from './screens/account/ProfileScreen'
import { Route as screensScreenerScreenerRedirectRouteImport } from './screens/screener/ScreenerRedirect'
import { Route as screensAccountSettingsScreenRouteImport } from './screens/account/SettingsScreen'
import { Route as screensAccountSubscriptionScreenRouteImport } from './screens/account/SubscriptionScreen'
import { Route as screensAppWatchlistScreenRouteImport } from './screens/app/WatchlistScreen'
import { Route as screensAuthForgotPasswordScreenRouteImport } from './screens/auth/ForgotPasswordScreen'
import { Route as screensAuthSignInScreenRouteImport } from './screens/auth/SignInScreen'
import { Route as screensAuthSignUpScreenRouteImport } from './screens/auth/SignUpScreen'
import { Route as screensAuthVerifyScreenRouteImport } from './screens/auth/VerifyScreen'
import { Route as screensChartChartRedirectRouteImport } from './screens/chart/ChartRedirect'
import { Route as screensOnboardingAllDoneScreenRouteImport } from './screens/onboarding/AllDoneScreen'
import { Route as screensOnboardingWhosClosestScreenRouteImport } from './screens/onboarding/WhosClosestScreen'
import { Route as screensOnboardingPickPlanScreenRouteImport } from './screens/onboarding/PickPlanScreen'
import { Route as screensBasketsBasketDetailScreenRouteImport } from './screens/baskets/BasketDetailScreen'
import { Route as screensBrokersBrokerScreenRouteImport } from './screens/brokers/BrokerScreen'
import { Route as screensBrokersAllBrokersScreenRouteImport } from './screens/brokers/AllBrokersScreen'
import { Route as screensBrokersByBrokerRedirectRouteImport } from './screens/brokers/ByBrokerRedirect'
import { Route as screensBrokersByStockRedirectRouteImport } from './screens/brokers/ByStockRedirect'
import { Route as screensBrokersCompareScreenRouteImport } from './screens/brokers/CompareScreen'
import { Route as screensBrokersLargeHoldingsScreenRouteImport } from './screens/brokers/LargeHoldingsScreen'
import { Route as screensBrokersLargeTradesScreenRouteImport } from './screens/brokers/LargeTradesScreen'
import { Route as screensBrokersLastMinuteScreenRouteImport } from './screens/brokers/LastMinuteScreen'
import { Route as screensBrokersMostTradedScreenRouteImport } from './screens/brokers/MostTradedScreen'
import { Route as screensBrokersPVRangeRedirectRouteImport } from './screens/brokers/PVRangeRedirect'
import { Route as screensBrokersReviewsRedirectRouteImport } from './screens/brokers/ReviewsRedirect'
import { Route as screensBrokersSectorFlowScreenRouteImport } from './screens/brokers/SectorFlowScreen'
import { Route as screensCoursesCourseDetailScreenRouteImport } from './screens/courses/CourseDetailScreen'
import { Route as screensCoursesCertificatesScreenRouteImport } from './screens/courses/CertificatesScreen'
import { Route as screensCoursesFaqScreenRouteImport } from './screens/courses/FaqScreen'
import { Route as screensCoursesMyLearningScreenRouteImport } from './screens/courses/MyLearningScreen'
import { Route as screensCoursesLearningPathScreenRouteImport } from './screens/courses/LearningPathScreen'
import { Route as screensDashboardsDashboardScreenRouteImport } from './screens/dashboards/DashboardScreen'
import { Route as screensDevComponentGalleryScreenRouteImport } from './screens/dev/ComponentGalleryScreen'
import { Route as screensIpoIpoScreenRouteImport } from './screens/ipo/IpoScreen'
import { Route as screensCoursesDictionaryScreenRouteImport } from './screens/courses/DictionaryScreen'
import { Route as screensMarketWeek52ScreenRouteImport } from './screens/market/Week52Screen'
import { Route as screensMarketDepthScreenRouteImport } from './screens/market/DepthScreen'
import { Route as screensMarketEventsScreenRouteImport } from './screens/market/EventsScreen'
import { Route as screensMarketFloorsheetScreenRouteImport } from './screens/market/FloorsheetScreen'
import { Route as screensMarketGainersLosersScreenRouteImport } from './screens/market/GainersLosersScreen'
import { Route as screensMarketHeatmapScreenRouteImport } from './screens/market/HeatmapScreen'
import { Route as screensMarketIndicesScreenRouteImport } from './screens/market/IndicesScreen'
import { Route as screensIpoPublicIssuesScreenRouteImport } from './screens/ipo/PublicIssuesScreen'
import { Route as screensMarketLiveMarketScreenRouteImport } from './screens/market/LiveMarketScreen'
import { Route as screensMarketMoversScreenRouteImport } from './screens/market/MoversScreen'
import { Route as screensMarketMarketNewsScreenRouteImport } from './screens/market/MarketNewsScreen'
import { Route as screensNewsletterNewslettersScreenRouteImport } from './screens/newsletter/NewslettersScreen'
import { Route as screensMarketStockPricesRedirectRouteImport } from './screens/market/StockPricesRedirect'
import { Route as screensMarketSectorsScreenRouteImport } from './screens/market/SectorsScreen'
import { Route as screensSignalsSignalZoneScreenRouteImport } from './screens/signals/SignalZoneScreen'
import { Route as screensMarketStockPricesScreenRouteImport } from './screens/market/StockPricesScreen'
import { Route as screensMarketStockTradingScreenRouteImport } from './screens/market/StockTradingScreen'
import { Route as screensMarketTradingAverageScreenRouteImport } from './screens/market/TradingAverageScreen'
import { Route as screensMarketMarketUpdateScreenRouteImport } from './screens/market/MarketUpdateScreen'
import { Route as screensMutualFundsDividendsScreenRouteImport } from './screens/mutual-funds/DividendsScreen'
import { Route as screensMutualFundsIndustryHoldingsScreenRouteImport } from './screens/mutual-funds/IndustryHoldingsScreen'
import { Route as screensMutualFundsMonthlyHoldingsRedirectRouteImport } from './screens/mutual-funds/MonthlyHoldingsRedirect'
import { Route as screensMutualFundsPriceVsNavScreenRouteImport } from './screens/mutual-funds/PriceVsNavScreen'
import { Route as screensMutualFundsRankingsScreenRouteImport } from './screens/mutual-funds/RankingsScreen'
import { Route as screensNewsletterNewsletterIssueRedirectRouteImport } from './screens/newsletter/NewsletterIssueRedirect'
import { Route as screensAccountPaymentFailedScreenRouteImport } from './screens/account/PaymentFailedScreen'
import { Route as screensAccountPaymentReturnScreenRouteImport } from './screens/account/PaymentReturnScreen'
import { Route as screensPortfolioActivityScreenRouteImport } from './screens/portfolio/ActivityScreen'
import { Route as screensPortfolioAllocationScreenRouteImport } from './screens/portfolio/AllocationScreen'
import { Route as screensPortfolioAnalyticsScreenRouteImport } from './screens/portfolio/AnalyticsScreen'
import { Route as screensPortfolioDashboardRedirectRouteImport } from './screens/portfolio/DashboardRedirect'
import { Route as screensPortfolioHealthScreenRouteImport } from './screens/portfolio/HealthScreen'
import { Route as screensPortfolioHoldingsScreenRouteImport } from './screens/portfolio/HoldingsScreen'
import { Route as screensPortfolioImportPortfolioScreenRouteImport } from './screens/portfolio/ImportPortfolioScreen'
import { Route as screensPortfolioIncomeScreenRouteImport } from './screens/portfolio/IncomeScreen'
import { Route as screensPostsPostScreenRouteImport } from './screens/posts/PostScreen'
import { Route as screensScreenerAdvancedScreenerScreenRouteImport } from './screens/screener/AdvancedScreenerScreen'
import { Route as screensStockStockScreenRouteImport } from './screens/stock/StockScreen'
import { Route as screensAccountBillingHistoryScreenRouteImport } from './screens/account/BillingHistoryScreen'
import { Route as screensAccountCheckoutScreenRouteImport } from './screens/account/CheckoutScreen'
import { Route as screensAccountManagePlanScreenRouteImport } from './screens/account/ManagePlanScreen'
import { Route as screensCoursesVerifyCertificateScreenRouteImport } from './screens/courses/VerifyCertificateScreen'
import { Route as screensChartChartScreenRouteImport } from './screens/chart/ChartScreen'
import { Route as screensBrokersBrokerReviewsScreenRouteImport } from './screens/brokers/BrokerReviewsScreen'
import { Route as screensBrokersByStockScreenRouteImport } from './screens/brokers/ByStockScreen'
import { Route as screensBrokersPVRangeScreenRouteImport } from './screens/brokers/PVRangeScreen'
import { Route as screensCoursesCourseCheckoutScreenRouteImport } from './screens/courses/CourseCheckoutScreen'
import { Route as screensCoursesPathStepScreenRouteImport } from './screens/courses/PathStepScreen'
import { Route as screensCoursesDictionaryTermScreenRouteImport } from './screens/courses/DictionaryTermScreen'
import { Route as screensMarketNewsArticleScreenRouteImport } from './screens/market/NewsArticleScreen'
import { Route as screensNewsletterNewsletterIssueScreenRouteImport } from './screens/newsletter/NewsletterIssueScreen'
import { Route as screensSignalsBreakoutsScreenRouteImport } from './screens/signals/BreakoutsScreen'
import { Route as screensSignalsCycleMapScreenRouteImport } from './screens/signals/CycleMapScreen'
import { Route as screensSignalsDailyForecastScreenRouteImport } from './screens/signals/DailyForecastScreen'
import { Route as screensSignalsEssentialsScreenRouteImport } from './screens/signals/EssentialsScreen'
import { Route as screensSignalsSignalHistoryScreenRouteImport } from './screens/signals/SignalHistoryScreen'
import { Route as screensSignalsLiveSignalsScreenRouteImport } from './screens/signals/LiveSignalsScreen'
import { Route as screensSignalsOpenTradesScreenRouteImport } from './screens/signals/OpenTradesScreen'
import { Route as screensSignalsTrendSignalsScreenRouteImport } from './screens/signals/TrendSignalsScreen'
import { Route as screensSignalsVolatileStocksScreenRouteImport } from './screens/signals/VolatileStocksScreen'
import { Route as screensMutualFundsFundScreenRouteImport } from './screens/mutual-funds/FundScreen'
import { Route as screensPortfolioAddWithMitraScreenRouteImport } from './screens/portfolio/AddWithMitraScreen'
import { Route as screensCoursesLectureScreenRouteImport } from './screens/courses/LectureScreen'
import { Route as screensSignalsSignalStockScreenRouteImport } from './screens/signals/SignalStockScreen'
import { Route as screensSignalsSignalTechnicalsScreenRouteImport } from './screens/signals/SignalTechnicalsScreen'

const routesLayoutsAppRoute = routesLayoutsAppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const routesLayoutsAuthRoute = routesLayoutsAuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const routesLayoutsPublicRoute = routesLayoutsPublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const routesLayoutsWorkspaceRoute = routesLayoutsWorkspaceRouteImport.update({
  id: '/_workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const screensOnboardingWelcomeScreenRoute =
  screensOnboardingWelcomeScreenRouteImport.update({
    id: '/welcome',
    path: '/welcome',
    getParentRoute: () => rootRouteImport,
  } as any)
const screensAppHomeScreenRoute = screensAppHomeScreenRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => routesLayoutsAppRoute,
} as any)
const screensAppAlertsScreenRoute = screensAppAlertsScreenRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => routesLayoutsAppRoute,
} as any)
const screensBasketsBasketsScreenRoute =
  screensBasketsBasketsScreenRouteImport.update({
    id: '/baskets',
    path: '/baskets',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensBrokersOverviewScreenRoute =
  screensBrokersOverviewScreenRouteImport.update({
    id: '/brokers',
    path: '/brokers',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensAppChatScreenRoute = screensAppChatScreenRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => routesLayoutsAppRoute,
} as any)
const screensAppCompaniesScreenRoute =
  screensAppCompaniesScreenRouteImport.update({
    id: '/companies',
    path: '/companies',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensCoursesCoursesScreenRoute =
  screensCoursesCoursesScreenRouteImport.update({
    id: '/courses',
    path: '/courses',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensDashboardsDashboardsScreenRoute =
  screensDashboardsDashboardsScreenRouteImport.update({
    id: '/dashboards',
    path: '/dashboards',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensIpoIssuesRedirectRoute =
  screensIpoIssuesRedirectRouteImport.update({
    id: '/issues',
    path: '/issues',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMarketOverviewScreenRoute =
  screensMarketOverviewScreenRouteImport.update({
    id: '/market',
    path: '/market',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMutualFundsAnalyticsScreenRoute =
  screensMutualFundsAnalyticsScreenRouteImport.update({
    id: '/mutual-funds',
    path: '/mutual-funds',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensNewsletterNewslettersRedirectRoute =
  screensNewsletterNewslettersRedirectRouteImport.update({
    id: '/newsletters',
    path: '/newsletters',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensAppNotificationsScreenRoute =
  screensAppNotificationsScreenRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensPortfolioOverviewScreenRoute =
  screensPortfolioOverviewScreenRouteImport.update({
    id: '/portfolio',
    path: '/portfolio',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensAccountProfileScreenRoute =
  screensAccountProfileScreenRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensScreenerScreenerRedirectRoute =
  screensScreenerScreenerRedirectRouteImport.update({
    id: '/screener',
    path: '/screener',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensAccountSettingsScreenRoute =
  screensAccountSettingsScreenRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensAccountSubscriptionScreenRoute =
  screensAccountSubscriptionScreenRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensAppWatchlistScreenRoute =
  screensAppWatchlistScreenRouteImport.update({
    id: '/watchlist',
    path: '/watchlist',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensAuthForgotPasswordScreenRoute =
  screensAuthForgotPasswordScreenRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => routesLayoutsAuthRoute,
  } as any)
const screensAuthSignInScreenRoute = screensAuthSignInScreenRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => routesLayoutsAuthRoute,
} as any)
const screensAuthSignUpScreenRoute = screensAuthSignUpScreenRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => routesLayoutsAuthRoute,
} as any)
const screensAuthVerifyScreenRoute = screensAuthVerifyScreenRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => routesLayoutsAuthRoute,
} as any)
const screensChartChartRedirectRoute =
  screensChartChartRedirectRouteImport.update({
    id: '/chart',
    path: '/chart',
    getParentRoute: () => routesLayoutsWorkspaceRoute,
  } as any)
const screensOnboardingAllDoneScreenRoute =
  screensOnboardingAllDoneScreenRouteImport.update({
    id: '/onboarding/done',
    path: '/onboarding/done',
    getParentRoute: () => rootRouteImport,
  } as any)
const screensOnboardingWhosClosestScreenRoute =
  screensOnboardingWhosClosestScreenRouteImport.update({
    id: '/onboarding/persona',
    path: '/onboarding/persona',
    getParentRoute: () => rootRouteImport,
  } as any)
const screensOnboardingPickPlanScreenRoute =
  screensOnboardingPickPlanScreenRouteImport.update({
    id: '/onboarding/plan',
    path: '/onboarding/plan',
    getParentRoute: () => rootRouteImport,
  } as any)
const screensBasketsBasketDetailScreenRoute =
  screensBasketsBasketDetailScreenRouteImport.update({
    id: '/baskets/$basketId',
    path: '/baskets/$basketId',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensBrokersBrokerScreenRoute =
  screensBrokersBrokerScreenRouteImport.update({
    id: '/brokers/$code',
    path: '/brokers/$code',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensBrokersAllBrokersScreenRoute =
  screensBrokersAllBrokersScreenRouteImport.update({
    id: '/brokers/all',
    path: '/brokers/all',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensBrokersByBrokerRedirectRoute =
  screensBrokersByBrokerRedirectRouteImport.update({
    id: '/brokers/by-broker',
    path: '/brokers/by-broker',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensBrokersByStockRedirectRoute =
  screensBrokersByStockRedirectRouteImport.update({
    id: '/brokers/by-stock',
    path: '/brokers/by-stock',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensBrokersCompareScreenRoute =
  screensBrokersCompareScreenRouteImport.update({
    id: '/brokers/compare',
    path: '/brokers/compare',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensBrokersLargeHoldingsScreenRoute =
  screensBrokersLargeHoldingsScreenRouteImport.update({
    id: '/brokers/large-holdings',
    path: '/brokers/large-holdings',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensBrokersLargeTradesScreenRoute =
  screensBrokersLargeTradesScreenRouteImport.update({
    id: '/brokers/large-trades',
    path: '/brokers/large-trades',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensBrokersLastMinuteScreenRoute =
  screensBrokersLastMinuteScreenRouteImport.update({
    id: '/brokers/last-minute',
    path: '/brokers/last-minute',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensBrokersMostTradedScreenRoute =
  screensBrokersMostTradedScreenRouteImport.update({
    id: '/brokers/most-traded',
    path: '/brokers/most-traded',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensBrokersPVRangeRedirectRoute =
  screensBrokersPVRangeRedirectRouteImport.update({
    id: '/brokers/pv-range',
    path: '/brokers/pv-range',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensBrokersReviewsRedirectRoute =
  screensBrokersReviewsRedirectRouteImport.update({
    id: '/brokers/reviews',
    path: '/brokers/reviews',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensBrokersSectorFlowScreenRoute =
  screensBrokersSectorFlowScreenRouteImport.update({
    id: '/brokers/sector-flow',
    path: '/brokers/sector-flow',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensCoursesCourseDetailScreenRoute =
  screensCoursesCourseDetailScreenRouteImport.update({
    id: '/courses/$courseId',
    path: '/courses/$courseId',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensCoursesCertificatesScreenRoute =
  screensCoursesCertificatesScreenRouteImport.update({
    id: '/courses/certificates',
    path: '/courses/certificates',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensCoursesFaqScreenRoute = screensCoursesFaqScreenRouteImport.update({
  id: '/courses/faq',
  path: '/courses/faq',
  getParentRoute: () => routesLayoutsAppRoute,
} as any)
const screensCoursesMyLearningScreenRoute =
  screensCoursesMyLearningScreenRouteImport.update({
    id: '/courses/my-learning',
    path: '/courses/my-learning',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensCoursesLearningPathScreenRoute =
  screensCoursesLearningPathScreenRouteImport.update({
    id: '/courses/path',
    path: '/courses/path',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensDashboardsDashboardScreenRoute =
  screensDashboardsDashboardScreenRouteImport.update({
    id: '/dashboards/$dashboardId',
    path: '/dashboards/$dashboardId',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensDevComponentGalleryScreenRoute =
  screensDevComponentGalleryScreenRouteImport.update({
    id: '/dev/components',
    path: '/dev/components',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensIpoIpoScreenRoute = screensIpoIpoScreenRouteImport.update({
  id: '/ipo/$key',
  path: '/ipo/$key',
  getParentRoute: () => routesLayoutsAppRoute,
} as any)
const screensCoursesDictionaryScreenRoute =
  screensCoursesDictionaryScreenRouteImport.update({
    id: '/learn/dictionary',
    path: '/learn/dictionary',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMarketWeek52ScreenRoute =
  screensMarketWeek52ScreenRouteImport.update({
    id: '/market/52-week',
    path: '/market/52-week',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMarketDepthScreenRoute =
  screensMarketDepthScreenRouteImport.update({
    id: '/market/depth',
    path: '/market/depth',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMarketEventsScreenRoute =
  screensMarketEventsScreenRouteImport.update({
    id: '/market/events',
    path: '/market/events',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMarketFloorsheetScreenRoute =
  screensMarketFloorsheetScreenRouteImport.update({
    id: '/market/floorsheet',
    path: '/market/floorsheet',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMarketGainersLosersScreenRoute =
  screensMarketGainersLosersScreenRouteImport.update({
    id: '/market/gainers-losers',
    path: '/market/gainers-losers',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMarketHeatmapScreenRoute =
  screensMarketHeatmapScreenRouteImport.update({
    id: '/market/heatmap',
    path: '/market/heatmap',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMarketIndicesScreenRoute =
  screensMarketIndicesScreenRouteImport.update({
    id: '/market/indices',
    path: '/market/indices',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensIpoPublicIssuesScreenRoute =
  screensIpoPublicIssuesScreenRouteImport.update({
    id: '/market/issues',
    path: '/market/issues',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMarketLiveMarketScreenRoute =
  screensMarketLiveMarketScreenRouteImport.update({
    id: '/market/live',
    path: '/market/live',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMarketMoversScreenRoute =
  screensMarketMoversScreenRouteImport.update({
    id: '/market/movers',
    path: '/market/movers',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMarketMarketNewsScreenRoute =
  screensMarketMarketNewsScreenRouteImport.update({
    id: '/market/news',
    path: '/market/news',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensNewsletterNewslettersScreenRoute =
  screensNewsletterNewslettersScreenRouteImport.update({
    id: '/market/newsletters',
    path: '/market/newsletters',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMarketStockPricesRedirectRoute =
  screensMarketStockPricesRedirectRouteImport.update({
    id: '/market/prices',
    path: '/market/prices',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMarketSectorsScreenRoute =
  screensMarketSectorsScreenRouteImport.update({
    id: '/market/sectors',
    path: '/market/sectors',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensSignalsSignalZoneScreenRoute =
  screensSignalsSignalZoneScreenRouteImport.update({
    id: '/market/signals',
    path: '/market/signals',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMarketStockPricesScreenRoute =
  screensMarketStockPricesScreenRouteImport.update({
    id: '/market/stock-prices',
    path: '/market/stock-prices',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMarketStockTradingScreenRoute =
  screensMarketStockTradingScreenRouteImport.update({
    id: '/market/stock-trading',
    path: '/market/stock-trading',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMarketTradingAverageScreenRoute =
  screensMarketTradingAverageScreenRouteImport.update({
    id: '/market/trading-average',
    path: '/market/trading-average',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMarketMarketUpdateScreenRoute =
  screensMarketMarketUpdateScreenRouteImport.update({
    id: '/market/update',
    path: '/market/update',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMutualFundsDividendsScreenRoute =
  screensMutualFundsDividendsScreenRouteImport.update({
    id: '/mutual-funds/dividends',
    path: '/mutual-funds/dividends',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMutualFundsIndustryHoldingsScreenRoute =
  screensMutualFundsIndustryHoldingsScreenRouteImport.update({
    id: '/mutual-funds/industry-holdings',
    path: '/mutual-funds/industry-holdings',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMutualFundsMonthlyHoldingsRedirectRoute =
  screensMutualFundsMonthlyHoldingsRedirectRouteImport.update({
    id: '/mutual-funds/monthly-holdings',
    path: '/mutual-funds/monthly-holdings',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMutualFundsPriceVsNavScreenRoute =
  screensMutualFundsPriceVsNavScreenRouteImport.update({
    id: '/mutual-funds/price-vs-nav',
    path: '/mutual-funds/price-vs-nav',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMutualFundsRankingsScreenRoute =
  screensMutualFundsRankingsScreenRouteImport.update({
    id: '/mutual-funds/rankings',
    path: '/mutual-funds/rankings',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensNewsletterNewsletterIssueRedirectRoute =
  screensNewsletterNewsletterIssueRedirectRouteImport.update({
    id: '/newsletters/$issueNumber',
    path: '/newsletters/$issueNumber',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensAccountPaymentFailedScreenRoute =
  screensAccountPaymentFailedScreenRouteImport.update({
    id: '/payment/failed',
    path: '/payment/failed',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensAccountPaymentReturnScreenRoute =
  screensAccountPaymentReturnScreenRouteImport.update({
    id: '/payment/return',
    path: '/payment/return',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensPortfolioActivityScreenRoute =
  screensPortfolioActivityScreenRouteImport.update({
    id: '/portfolio/activity',
    path: '/portfolio/activity',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensPortfolioAllocationScreenRoute =
  screensPortfolioAllocationScreenRouteImport.update({
    id: '/portfolio/allocation',
    path: '/portfolio/allocation',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensPortfolioAnalyticsScreenRoute =
  screensPortfolioAnalyticsScreenRouteImport.update({
    id: '/portfolio/analytics',
    path: '/portfolio/analytics',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensPortfolioDashboardRedirectRoute =
  screensPortfolioDashboardRedirectRouteImport.update({
    id: '/portfolio/dashboard',
    path: '/portfolio/dashboard',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensPortfolioHealthScreenRoute =
  screensPortfolioHealthScreenRouteImport.update({
    id: '/portfolio/health',
    path: '/portfolio/health',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensPortfolioHoldingsScreenRoute =
  screensPortfolioHoldingsScreenRouteImport.update({
    id: '/portfolio/holdings',
    path: '/portfolio/holdings',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensPortfolioImportPortfolioScreenRoute =
  screensPortfolioImportPortfolioScreenRouteImport.update({
    id: '/portfolio/import',
    path: '/portfolio/import',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensPortfolioIncomeScreenRoute =
  screensPortfolioIncomeScreenRouteImport.update({
    id: '/portfolio/income',
    path: '/portfolio/income',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensPostsPostScreenRoute = screensPostsPostScreenRouteImport.update({
  id: '/posts/$postId',
  path: '/posts/$postId',
  getParentRoute: () => routesLayoutsAppRoute,
} as any)
const screensScreenerAdvancedScreenerScreenRoute =
  screensScreenerAdvancedScreenerScreenRouteImport.update({
    id: '/screener/advanced',
    path: '/screener/advanced',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensStockStockScreenRoute = screensStockStockScreenRouteImport.update({
  id: '/stocks/$symbol',
  path: '/stocks/$symbol',
  getParentRoute: () => routesLayoutsAppRoute,
} as any)
const screensAccountBillingHistoryScreenRoute =
  screensAccountBillingHistoryScreenRouteImport.update({
    id: '/subscription/billing',
    path: '/subscription/billing',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensAccountCheckoutScreenRoute =
  screensAccountCheckoutScreenRouteImport.update({
    id: '/subscription/checkout',
    path: '/subscription/checkout',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensAccountManagePlanScreenRoute =
  screensAccountManagePlanScreenRouteImport.update({
    id: '/subscription/manage',
    path: '/subscription/manage',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensCoursesVerifyCertificateScreenRoute =
  screensCoursesVerifyCertificateScreenRouteImport.update({
    id: '/verify/$code',
    path: '/verify/$code',
    getParentRoute: () => routesLayoutsPublicRoute,
  } as any)
const screensChartChartScreenRoute = screensChartChartScreenRouteImport.update({
  id: '/chart/$symbol',
  path: '/chart/$symbol',
  getParentRoute: () => routesLayoutsWorkspaceRoute,
} as any)
const screensBrokersBrokerReviewsScreenRoute =
  screensBrokersBrokerReviewsScreenRouteImport.update({
    id: '/brokers/$code/reviews',
    path: '/brokers/$code/reviews',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensBrokersByStockScreenRoute =
  screensBrokersByStockScreenRouteImport.update({
    id: '/brokers/by-stock/$symbol',
    path: '/brokers/by-stock/$symbol',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensBrokersPVRangeScreenRoute =
  screensBrokersPVRangeScreenRouteImport.update({
    id: '/brokers/pv-range/$symbol',
    path: '/brokers/pv-range/$symbol',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensCoursesCourseCheckoutScreenRoute =
  screensCoursesCourseCheckoutScreenRouteImport.update({
    id: '/courses/$courseId/checkout',
    path: '/courses/$courseId/checkout',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensCoursesPathStepScreenRoute =
  screensCoursesPathStepScreenRouteImport.update({
    id: '/courses/path/$stepId',
    path: '/courses/path/$stepId',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensCoursesDictionaryTermScreenRoute =
  screensCoursesDictionaryTermScreenRouteImport.update({
    id: '/learn/dictionary/$slug',
    path: '/learn/dictionary/$slug',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMarketNewsArticleScreenRoute =
  screensMarketNewsArticleScreenRouteImport.update({
    id: '/market/news/article',
    path: '/market/news/article',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensNewsletterNewsletterIssueScreenRoute =
  screensNewsletterNewsletterIssueScreenRouteImport.update({
    id: '/market/newsletters/$issueNumber',
    path: '/market/newsletters/$issueNumber',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensSignalsBreakoutsScreenRoute =
  screensSignalsBreakoutsScreenRouteImport.update({
    id: '/market/signals/breakouts',
    path: '/market/signals/breakouts',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensSignalsCycleMapScreenRoute =
  screensSignalsCycleMapScreenRouteImport.update({
    id: '/market/signals/cycle-map',
    path: '/market/signals/cycle-map',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensSignalsDailyForecastScreenRoute =
  screensSignalsDailyForecastScreenRouteImport.update({
    id: '/market/signals/daily',
    path: '/market/signals/daily',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensSignalsEssentialsScreenRoute =
  screensSignalsEssentialsScreenRouteImport.update({
    id: '/market/signals/essentials',
    path: '/market/signals/essentials',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensSignalsSignalHistoryScreenRoute =
  screensSignalsSignalHistoryScreenRouteImport.update({
    id: '/market/signals/history',
    path: '/market/signals/history',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensSignalsLiveSignalsScreenRoute =
  screensSignalsLiveSignalsScreenRouteImport.update({
    id: '/market/signals/live',
    path: '/market/signals/live',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensSignalsOpenTradesScreenRoute =
  screensSignalsOpenTradesScreenRouteImport.update({
    id: '/market/signals/open-trades',
    path: '/market/signals/open-trades',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensSignalsTrendSignalsScreenRoute =
  screensSignalsTrendSignalsScreenRouteImport.update({
    id: '/market/signals/trend',
    path: '/market/signals/trend',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensSignalsVolatileStocksScreenRoute =
  screensSignalsVolatileStocksScreenRouteImport.update({
    id: '/market/signals/volatile',
    path: '/market/signals/volatile',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensMutualFundsFundScreenRoute =
  screensMutualFundsFundScreenRouteImport.update({
    id: '/mutual-funds/fund/$symbol',
    path: '/mutual-funds/fund/$symbol',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensPortfolioAddWithMitraScreenRoute =
  screensPortfolioAddWithMitraScreenRouteImport.update({
    id: '/portfolio/add/ai',
    path: '/portfolio/add/ai',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensCoursesLectureScreenRoute =
  screensCoursesLectureScreenRouteImport.update({
    id: '/courses/$courseId/lectures/$lectureId',
    path: '/courses/$courseId/lectures/$lectureId',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensSignalsSignalStockScreenRoute =
  screensSignalsSignalStockScreenRouteImport.update({
    id: '/market/signals/stock/$symbol',
    path: '/market/signals/stock/$symbol',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)
const screensSignalsSignalTechnicalsScreenRoute =
  screensSignalsSignalTechnicalsScreenRouteImport.update({
    id: '/market/signals/stock/$symbol/technicals',
    path: '/market/signals/stock/$symbol/technicals',
    getParentRoute: () => routesLayoutsAppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof screensAppHomeScreenRoute
  '/welcome': typeof screensOnboardingWelcomeScreenRoute
  '/alerts': typeof screensAppAlertsScreenRoute
  '/baskets': typeof screensBasketsBasketsScreenRoute
  '/brokers': typeof screensBrokersOverviewScreenRoute
  '/chat': typeof screensAppChatScreenRoute
  '/companies': typeof screensAppCompaniesScreenRoute
  '/courses': typeof screensCoursesCoursesScreenRoute
  '/dashboards': typeof screensDashboardsDashboardsScreenRoute
  '/issues': typeof screensIpoIssuesRedirectRoute
  '/market': typeof screensMarketOverviewScreenRoute
  '/mutual-funds': typeof screensMutualFundsAnalyticsScreenRoute
  '/newsletters': typeof screensNewsletterNewslettersRedirectRoute
  '/notifications': typeof screensAppNotificationsScreenRoute
  '/portfolio': typeof screensPortfolioOverviewScreenRoute
  '/profile': typeof screensAccountProfileScreenRoute
  '/screener': typeof screensScreenerScreenerRedirectRoute
  '/settings': typeof screensAccountSettingsScreenRoute
  '/subscription': typeof screensAccountSubscriptionScreenRoute
  '/watchlist': typeof screensAppWatchlistScreenRoute
  '/forgot-password': typeof screensAuthForgotPasswordScreenRoute
  '/signin': typeof screensAuthSignInScreenRoute
  '/signup': typeof screensAuthSignUpScreenRoute
  '/verify': typeof screensAuthVerifyScreenRoute
  '/chart': typeof screensChartChartRedirectRoute
  '/onboarding/done': typeof screensOnboardingAllDoneScreenRoute
  '/onboarding/persona': typeof screensOnboardingWhosClosestScreenRoute
  '/onboarding/plan': typeof screensOnboardingPickPlanScreenRoute
  '/baskets/$basketId': typeof screensBasketsBasketDetailScreenRoute
  '/brokers/$code': typeof screensBrokersBrokerScreenRoute
  '/brokers/all': typeof screensBrokersAllBrokersScreenRoute
  '/brokers/by-broker': typeof screensBrokersByBrokerRedirectRoute
  '/brokers/by-stock': typeof screensBrokersByStockRedirectRoute
  '/brokers/compare': typeof screensBrokersCompareScreenRoute
  '/brokers/large-holdings': typeof screensBrokersLargeHoldingsScreenRoute
  '/brokers/large-trades': typeof screensBrokersLargeTradesScreenRoute
  '/brokers/last-minute': typeof screensBrokersLastMinuteScreenRoute
  '/brokers/most-traded': typeof screensBrokersMostTradedScreenRoute
  '/brokers/pv-range': typeof screensBrokersPVRangeRedirectRoute
  '/brokers/reviews': typeof screensBrokersReviewsRedirectRoute
  '/brokers/sector-flow': typeof screensBrokersSectorFlowScreenRoute
  '/courses/$courseId': typeof screensCoursesCourseDetailScreenRoute
  '/courses/certificates': typeof screensCoursesCertificatesScreenRoute
  '/courses/faq': typeof screensCoursesFaqScreenRoute
  '/courses/my-learning': typeof screensCoursesMyLearningScreenRoute
  '/courses/path': typeof screensCoursesLearningPathScreenRoute
  '/dashboards/$dashboardId': typeof screensDashboardsDashboardScreenRoute
  '/dev/components': typeof screensDevComponentGalleryScreenRoute
  '/ipo/$key': typeof screensIpoIpoScreenRoute
  '/learn/dictionary': typeof screensCoursesDictionaryScreenRoute
  '/market/52-week': typeof screensMarketWeek52ScreenRoute
  '/market/depth': typeof screensMarketDepthScreenRoute
  '/market/events': typeof screensMarketEventsScreenRoute
  '/market/floorsheet': typeof screensMarketFloorsheetScreenRoute
  '/market/gainers-losers': typeof screensMarketGainersLosersScreenRoute
  '/market/heatmap': typeof screensMarketHeatmapScreenRoute
  '/market/indices': typeof screensMarketIndicesScreenRoute
  '/market/issues': typeof screensIpoPublicIssuesScreenRoute
  '/market/live': typeof screensMarketLiveMarketScreenRoute
  '/market/movers': typeof screensMarketMoversScreenRoute
  '/market/news': typeof screensMarketMarketNewsScreenRoute
  '/market/newsletters': typeof screensNewsletterNewslettersScreenRoute
  '/market/prices': typeof screensMarketStockPricesRedirectRoute
  '/market/sectors': typeof screensMarketSectorsScreenRoute
  '/market/signals': typeof screensSignalsSignalZoneScreenRoute
  '/market/stock-prices': typeof screensMarketStockPricesScreenRoute
  '/market/stock-trading': typeof screensMarketStockTradingScreenRoute
  '/market/trading-average': typeof screensMarketTradingAverageScreenRoute
  '/market/update': typeof screensMarketMarketUpdateScreenRoute
  '/mutual-funds/dividends': typeof screensMutualFundsDividendsScreenRoute
  '/mutual-funds/industry-holdings': typeof screensMutualFundsIndustryHoldingsScreenRoute
  '/mutual-funds/monthly-holdings': typeof screensMutualFundsMonthlyHoldingsRedirectRoute
  '/mutual-funds/price-vs-nav': typeof screensMutualFundsPriceVsNavScreenRoute
  '/mutual-funds/rankings': typeof screensMutualFundsRankingsScreenRoute
  '/newsletters/$issueNumber': typeof screensNewsletterNewsletterIssueRedirectRoute
  '/payment/failed': typeof screensAccountPaymentFailedScreenRoute
  '/payment/return': typeof screensAccountPaymentReturnScreenRoute
  '/portfolio/activity': typeof screensPortfolioActivityScreenRoute
  '/portfolio/allocation': typeof screensPortfolioAllocationScreenRoute
  '/portfolio/analytics': typeof screensPortfolioAnalyticsScreenRoute
  '/portfolio/dashboard': typeof screensPortfolioDashboardRedirectRoute
  '/portfolio/health': typeof screensPortfolioHealthScreenRoute
  '/portfolio/holdings': typeof screensPortfolioHoldingsScreenRoute
  '/portfolio/import': typeof screensPortfolioImportPortfolioScreenRoute
  '/portfolio/income': typeof screensPortfolioIncomeScreenRoute
  '/posts/$postId': typeof screensPostsPostScreenRoute
  '/screener/advanced': typeof screensScreenerAdvancedScreenerScreenRoute
  '/stocks/$symbol': typeof screensStockStockScreenRoute
  '/subscription/billing': typeof screensAccountBillingHistoryScreenRoute
  '/subscription/checkout': typeof screensAccountCheckoutScreenRoute
  '/subscription/manage': typeof screensAccountManagePlanScreenRoute
  '/verify/$code': typeof screensCoursesVerifyCertificateScreenRoute
  '/chart/$symbol': typeof screensChartChartScreenRoute
  '/brokers/$code/reviews': typeof screensBrokersBrokerReviewsScreenRoute
  '/brokers/by-stock/$symbol': typeof screensBrokersByStockScreenRoute
  '/brokers/pv-range/$symbol': typeof screensBrokersPVRangeScreenRoute
  '/courses/$courseId/checkout': typeof screensCoursesCourseCheckoutScreenRoute
  '/courses/path/$stepId': typeof screensCoursesPathStepScreenRoute
  '/learn/dictionary/$slug': typeof screensCoursesDictionaryTermScreenRoute
  '/market/news/article': typeof screensMarketNewsArticleScreenRoute
  '/market/newsletters/$issueNumber': typeof screensNewsletterNewsletterIssueScreenRoute
  '/market/signals/breakouts': typeof screensSignalsBreakoutsScreenRoute
  '/market/signals/cycle-map': typeof screensSignalsCycleMapScreenRoute
  '/market/signals/daily': typeof screensSignalsDailyForecastScreenRoute
  '/market/signals/essentials': typeof screensSignalsEssentialsScreenRoute
  '/market/signals/history': typeof screensSignalsSignalHistoryScreenRoute
  '/market/signals/live': typeof screensSignalsLiveSignalsScreenRoute
  '/market/signals/open-trades': typeof screensSignalsOpenTradesScreenRoute
  '/market/signals/trend': typeof screensSignalsTrendSignalsScreenRoute
  '/market/signals/volatile': typeof screensSignalsVolatileStocksScreenRoute
  '/mutual-funds/fund/$symbol': typeof screensMutualFundsFundScreenRoute
  '/portfolio/add/ai': typeof screensPortfolioAddWithMitraScreenRoute
  '/courses/$courseId/lectures/$lectureId': typeof screensCoursesLectureScreenRoute
  '/market/signals/stock/$symbol': typeof screensSignalsSignalStockScreenRoute
  '/market/signals/stock/$symbol/technicals': typeof screensSignalsSignalTechnicalsScreenRoute
}
export interface FileRoutesByTo {
  '/': typeof screensAppHomeScreenRoute
  '/welcome': typeof screensOnboardingWelcomeScreenRoute
  '/alerts': typeof screensAppAlertsScreenRoute
  '/baskets': typeof screensBasketsBasketsScreenRoute
  '/brokers': typeof screensBrokersOverviewScreenRoute
  '/chat': typeof screensAppChatScreenRoute
  '/companies': typeof screensAppCompaniesScreenRoute
  '/courses': typeof screensCoursesCoursesScreenRoute
  '/dashboards': typeof screensDashboardsDashboardsScreenRoute
  '/issues': typeof screensIpoIssuesRedirectRoute
  '/market': typeof screensMarketOverviewScreenRoute
  '/mutual-funds': typeof screensMutualFundsAnalyticsScreenRoute
  '/newsletters': typeof screensNewsletterNewslettersRedirectRoute
  '/notifications': typeof screensAppNotificationsScreenRoute
  '/portfolio': typeof screensPortfolioOverviewScreenRoute
  '/profile': typeof screensAccountProfileScreenRoute
  '/screener': typeof screensScreenerScreenerRedirectRoute
  '/settings': typeof screensAccountSettingsScreenRoute
  '/subscription': typeof screensAccountSubscriptionScreenRoute
  '/watchlist': typeof screensAppWatchlistScreenRoute
  '/forgot-password': typeof screensAuthForgotPasswordScreenRoute
  '/signin': typeof screensAuthSignInScreenRoute
  '/signup': typeof screensAuthSignUpScreenRoute
  '/verify': typeof screensAuthVerifyScreenRoute
  '/chart': typeof screensChartChartRedirectRoute
  '/onboarding/done': typeof screensOnboardingAllDoneScreenRoute
  '/onboarding/persona': typeof screensOnboardingWhosClosestScreenRoute
  '/onboarding/plan': typeof screensOnboardingPickPlanScreenRoute
  '/baskets/$basketId': typeof screensBasketsBasketDetailScreenRoute
  '/brokers/$code': typeof screensBrokersBrokerScreenRoute
  '/brokers/all': typeof screensBrokersAllBrokersScreenRoute
  '/brokers/by-broker': typeof screensBrokersByBrokerRedirectRoute
  '/brokers/by-stock': typeof screensBrokersByStockRedirectRoute
  '/brokers/compare': typeof screensBrokersCompareScreenRoute
  '/brokers/large-holdings': typeof screensBrokersLargeHoldingsScreenRoute
  '/brokers/large-trades': typeof screensBrokersLargeTradesScreenRoute
  '/brokers/last-minute': typeof screensBrokersLastMinuteScreenRoute
  '/brokers/most-traded': typeof screensBrokersMostTradedScreenRoute
  '/brokers/pv-range': typeof screensBrokersPVRangeRedirectRoute
  '/brokers/reviews': typeof screensBrokersReviewsRedirectRoute
  '/brokers/sector-flow': typeof screensBrokersSectorFlowScreenRoute
  '/courses/$courseId': typeof screensCoursesCourseDetailScreenRoute
  '/courses/certificates': typeof screensCoursesCertificatesScreenRoute
  '/courses/faq': typeof screensCoursesFaqScreenRoute
  '/courses/my-learning': typeof screensCoursesMyLearningScreenRoute
  '/courses/path': typeof screensCoursesLearningPathScreenRoute
  '/dashboards/$dashboardId': typeof screensDashboardsDashboardScreenRoute
  '/dev/components': typeof screensDevComponentGalleryScreenRoute
  '/ipo/$key': typeof screensIpoIpoScreenRoute
  '/learn/dictionary': typeof screensCoursesDictionaryScreenRoute
  '/market/52-week': typeof screensMarketWeek52ScreenRoute
  '/market/depth': typeof screensMarketDepthScreenRoute
  '/market/events': typeof screensMarketEventsScreenRoute
  '/market/floorsheet': typeof screensMarketFloorsheetScreenRoute
  '/market/gainers-losers': typeof screensMarketGainersLosersScreenRoute
  '/market/heatmap': typeof screensMarketHeatmapScreenRoute
  '/market/indices': typeof screensMarketIndicesScreenRoute
  '/market/issues': typeof screensIpoPublicIssuesScreenRoute
  '/market/live': typeof screensMarketLiveMarketScreenRoute
  '/market/movers': typeof screensMarketMoversScreenRoute
  '/market/news': typeof screensMarketMarketNewsScreenRoute
  '/market/newsletters': typeof screensNewsletterNewslettersScreenRoute
  '/market/prices': typeof screensMarketStockPricesRedirectRoute
  '/market/sectors': typeof screensMarketSectorsScreenRoute
  '/market/signals': typeof screensSignalsSignalZoneScreenRoute
  '/market/stock-prices': typeof screensMarketStockPricesScreenRoute
  '/market/stock-trading': typeof screensMarketStockTradingScreenRoute
  '/market/trading-average': typeof screensMarketTradingAverageScreenRoute
  '/market/update': typeof screensMarketMarketUpdateScreenRoute
  '/mutual-funds/dividends': typeof screensMutualFundsDividendsScreenRoute
  '/mutual-funds/industry-holdings': typeof screensMutualFundsIndustryHoldingsScreenRoute
  '/mutual-funds/monthly-holdings': typeof screensMutualFundsMonthlyHoldingsRedirectRoute
  '/mutual-funds/price-vs-nav': typeof screensMutualFundsPriceVsNavScreenRoute
  '/mutual-funds/rankings': typeof screensMutualFundsRankingsScreenRoute
  '/newsletters/$issueNumber': typeof screensNewsletterNewsletterIssueRedirectRoute
  '/payment/failed': typeof screensAccountPaymentFailedScreenRoute
  '/payment/return': typeof screensAccountPaymentReturnScreenRoute
  '/portfolio/activity': typeof screensPortfolioActivityScreenRoute
  '/portfolio/allocation': typeof screensPortfolioAllocationScreenRoute
  '/portfolio/analytics': typeof screensPortfolioAnalyticsScreenRoute
  '/portfolio/dashboard': typeof screensPortfolioDashboardRedirectRoute
  '/portfolio/health': typeof screensPortfolioHealthScreenRoute
  '/portfolio/holdings': typeof screensPortfolioHoldingsScreenRoute
  '/portfolio/import': typeof screensPortfolioImportPortfolioScreenRoute
  '/portfolio/income': typeof screensPortfolioIncomeScreenRoute
  '/posts/$postId': typeof screensPostsPostScreenRoute
  '/screener/advanced': typeof screensScreenerAdvancedScreenerScreenRoute
  '/stocks/$symbol': typeof screensStockStockScreenRoute
  '/subscription/billing': typeof screensAccountBillingHistoryScreenRoute
  '/subscription/checkout': typeof screensAccountCheckoutScreenRoute
  '/subscription/manage': typeof screensAccountManagePlanScreenRoute
  '/verify/$code': typeof screensCoursesVerifyCertificateScreenRoute
  '/chart/$symbol': typeof screensChartChartScreenRoute
  '/brokers/$code/reviews': typeof screensBrokersBrokerReviewsScreenRoute
  '/brokers/by-stock/$symbol': typeof screensBrokersByStockScreenRoute
  '/brokers/pv-range/$symbol': typeof screensBrokersPVRangeScreenRoute
  '/courses/$courseId/checkout': typeof screensCoursesCourseCheckoutScreenRoute
  '/courses/path/$stepId': typeof screensCoursesPathStepScreenRoute
  '/learn/dictionary/$slug': typeof screensCoursesDictionaryTermScreenRoute
  '/market/news/article': typeof screensMarketNewsArticleScreenRoute
  '/market/newsletters/$issueNumber': typeof screensNewsletterNewsletterIssueScreenRoute
  '/market/signals/breakouts': typeof screensSignalsBreakoutsScreenRoute
  '/market/signals/cycle-map': typeof screensSignalsCycleMapScreenRoute
  '/market/signals/daily': typeof screensSignalsDailyForecastScreenRoute
  '/market/signals/essentials': typeof screensSignalsEssentialsScreenRoute
  '/market/signals/history': typeof screensSignalsSignalHistoryScreenRoute
  '/market/signals/live': typeof screensSignalsLiveSignalsScreenRoute
  '/market/signals/open-trades': typeof screensSignalsOpenTradesScreenRoute
  '/market/signals/trend': typeof screensSignalsTrendSignalsScreenRoute
  '/market/signals/volatile': typeof screensSignalsVolatileStocksScreenRoute
  '/mutual-funds/fund/$symbol': typeof screensMutualFundsFundScreenRoute
  '/portfolio/add/ai': typeof screensPortfolioAddWithMitraScreenRoute
  '/courses/$courseId/lectures/$lectureId': typeof screensCoursesLectureScreenRoute
  '/market/signals/stock/$symbol': typeof screensSignalsSignalStockScreenRoute
  '/market/signals/stock/$symbol/technicals': typeof screensSignalsSignalTechnicalsScreenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof routesLayoutsAppRouteWithChildren
  '/_auth': typeof routesLayoutsAuthRouteWithChildren
  '/_public': typeof routesLayoutsPublicRouteWithChildren
  '/_workspace': typeof routesLayoutsWorkspaceRouteWithChildren
  '/welcome': typeof screensOnboardingWelcomeScreenRoute
  '/_app/': typeof screensAppHomeScreenRoute
  '/_app/alerts': typeof screensAppAlertsScreenRoute
  '/_app/baskets': typeof screensBasketsBasketsScreenRoute
  '/_app/brokers': typeof screensBrokersOverviewScreenRoute
  '/_app/chat': typeof screensAppChatScreenRoute
  '/_app/companies': typeof screensAppCompaniesScreenRoute
  '/_app/courses': typeof screensCoursesCoursesScreenRoute
  '/_app/dashboards': typeof screensDashboardsDashboardsScreenRoute
  '/_app/issues': typeof screensIpoIssuesRedirectRoute
  '/_app/market': typeof screensMarketOverviewScreenRoute
  '/_app/mutual-funds': typeof screensMutualFundsAnalyticsScreenRoute
  '/_app/newsletters': typeof screensNewsletterNewslettersRedirectRoute
  '/_app/notifications': typeof screensAppNotificationsScreenRoute
  '/_app/portfolio': typeof screensPortfolioOverviewScreenRoute
  '/_app/profile': typeof screensAccountProfileScreenRoute
  '/_app/screener': typeof screensScreenerScreenerRedirectRoute
  '/_app/settings': typeof screensAccountSettingsScreenRoute
  '/_app/subscription': typeof screensAccountSubscriptionScreenRoute
  '/_app/watchlist': typeof screensAppWatchlistScreenRoute
  '/_auth/forgot-password': typeof screensAuthForgotPasswordScreenRoute
  '/_auth/signin': typeof screensAuthSignInScreenRoute
  '/_auth/signup': typeof screensAuthSignUpScreenRoute
  '/_auth/verify': typeof screensAuthVerifyScreenRoute
  '/_workspace/chart': typeof screensChartChartRedirectRoute
  '/onboarding/done': typeof screensOnboardingAllDoneScreenRoute
  '/onboarding/persona': typeof screensOnboardingWhosClosestScreenRoute
  '/onboarding/plan': typeof screensOnboardingPickPlanScreenRoute
  '/_app/baskets/$basketId': typeof screensBasketsBasketDetailScreenRoute
  '/_app/brokers/$code': typeof screensBrokersBrokerScreenRoute
  '/_app/brokers/all': typeof screensBrokersAllBrokersScreenRoute
  '/_app/brokers/by-broker': typeof screensBrokersByBrokerRedirectRoute
  '/_app/brokers/by-stock': typeof screensBrokersByStockRedirectRoute
  '/_app/brokers/compare': typeof screensBrokersCompareScreenRoute
  '/_app/brokers/large-holdings': typeof screensBrokersLargeHoldingsScreenRoute
  '/_app/brokers/large-trades': typeof screensBrokersLargeTradesScreenRoute
  '/_app/brokers/last-minute': typeof screensBrokersLastMinuteScreenRoute
  '/_app/brokers/most-traded': typeof screensBrokersMostTradedScreenRoute
  '/_app/brokers/pv-range': typeof screensBrokersPVRangeRedirectRoute
  '/_app/brokers/reviews': typeof screensBrokersReviewsRedirectRoute
  '/_app/brokers/sector-flow': typeof screensBrokersSectorFlowScreenRoute
  '/_app/courses/$courseId': typeof screensCoursesCourseDetailScreenRoute
  '/_app/courses/certificates': typeof screensCoursesCertificatesScreenRoute
  '/_app/courses/faq': typeof screensCoursesFaqScreenRoute
  '/_app/courses/my-learning': typeof screensCoursesMyLearningScreenRoute
  '/_app/courses/path': typeof screensCoursesLearningPathScreenRoute
  '/_app/dashboards/$dashboardId': typeof screensDashboardsDashboardScreenRoute
  '/_app/dev/components': typeof screensDevComponentGalleryScreenRoute
  '/_app/ipo/$key': typeof screensIpoIpoScreenRoute
  '/_app/learn/dictionary': typeof screensCoursesDictionaryScreenRoute
  '/_app/market/52-week': typeof screensMarketWeek52ScreenRoute
  '/_app/market/depth': typeof screensMarketDepthScreenRoute
  '/_app/market/events': typeof screensMarketEventsScreenRoute
  '/_app/market/floorsheet': typeof screensMarketFloorsheetScreenRoute
  '/_app/market/gainers-losers': typeof screensMarketGainersLosersScreenRoute
  '/_app/market/heatmap': typeof screensMarketHeatmapScreenRoute
  '/_app/market/indices': typeof screensMarketIndicesScreenRoute
  '/_app/market/issues': typeof screensIpoPublicIssuesScreenRoute
  '/_app/market/live': typeof screensMarketLiveMarketScreenRoute
  '/_app/market/movers': typeof screensMarketMoversScreenRoute
  '/_app/market/news': typeof screensMarketMarketNewsScreenRoute
  '/_app/market/newsletters': typeof screensNewsletterNewslettersScreenRoute
  '/_app/market/prices': typeof screensMarketStockPricesRedirectRoute
  '/_app/market/sectors': typeof screensMarketSectorsScreenRoute
  '/_app/market/signals': typeof screensSignalsSignalZoneScreenRoute
  '/_app/market/stock-prices': typeof screensMarketStockPricesScreenRoute
  '/_app/market/stock-trading': typeof screensMarketStockTradingScreenRoute
  '/_app/market/trading-average': typeof screensMarketTradingAverageScreenRoute
  '/_app/market/update': typeof screensMarketMarketUpdateScreenRoute
  '/_app/mutual-funds/dividends': typeof screensMutualFundsDividendsScreenRoute
  '/_app/mutual-funds/industry-holdings': typeof screensMutualFundsIndustryHoldingsScreenRoute
  '/_app/mutual-funds/monthly-holdings': typeof screensMutualFundsMonthlyHoldingsRedirectRoute
  '/_app/mutual-funds/price-vs-nav': typeof screensMutualFundsPriceVsNavScreenRoute
  '/_app/mutual-funds/rankings': typeof screensMutualFundsRankingsScreenRoute
  '/_app/newsletters/$issueNumber': typeof screensNewsletterNewsletterIssueRedirectRoute
  '/_app/payment/failed': typeof screensAccountPaymentFailedScreenRoute
  '/_app/payment/return': typeof screensAccountPaymentReturnScreenRoute
  '/_app/portfolio/activity': typeof screensPortfolioActivityScreenRoute
  '/_app/portfolio/allocation': typeof screensPortfolioAllocationScreenRoute
  '/_app/portfolio/analytics': typeof screensPortfolioAnalyticsScreenRoute
  '/_app/portfolio/dashboard': typeof screensPortfolioDashboardRedirectRoute
  '/_app/portfolio/health': typeof screensPortfolioHealthScreenRoute
  '/_app/portfolio/holdings': typeof screensPortfolioHoldingsScreenRoute
  '/_app/portfolio/import': typeof screensPortfolioImportPortfolioScreenRoute
  '/_app/portfolio/income': typeof screensPortfolioIncomeScreenRoute
  '/_app/posts/$postId': typeof screensPostsPostScreenRoute
  '/_app/screener/advanced': typeof screensScreenerAdvancedScreenerScreenRoute
  '/_app/stocks/$symbol': typeof screensStockStockScreenRoute
  '/_app/subscription/billing': typeof screensAccountBillingHistoryScreenRoute
  '/_app/subscription/checkout': typeof screensAccountCheckoutScreenRoute
  '/_app/subscription/manage': typeof screensAccountManagePlanScreenRoute
  '/_public/verify/$code': typeof screensCoursesVerifyCertificateScreenRoute
  '/_workspace/chart/$symbol': typeof screensChartChartScreenRoute
  '/_app/brokers/$code/reviews': typeof screensBrokersBrokerReviewsScreenRoute
  '/_app/brokers/by-stock/$symbol': typeof screensBrokersByStockScreenRoute
  '/_app/brokers/pv-range/$symbol': typeof screensBrokersPVRangeScreenRoute
  '/_app/courses/$courseId/checkout': typeof screensCoursesCourseCheckoutScreenRoute
  '/_app/courses/path/$stepId': typeof screensCoursesPathStepScreenRoute
  '/_app/learn/dictionary/$slug': typeof screensCoursesDictionaryTermScreenRoute
  '/_app/market/news/article': typeof screensMarketNewsArticleScreenRoute
  '/_app/market/newsletters/$issueNumber': typeof screensNewsletterNewsletterIssueScreenRoute
  '/_app/market/signals/breakouts': typeof screensSignalsBreakoutsScreenRoute
  '/_app/market/signals/cycle-map': typeof screensSignalsCycleMapScreenRoute
  '/_app/market/signals/daily': typeof screensSignalsDailyForecastScreenRoute
  '/_app/market/signals/essentials': typeof screensSignalsEssentialsScreenRoute
  '/_app/market/signals/history': typeof screensSignalsSignalHistoryScreenRoute
  '/_app/market/signals/live': typeof screensSignalsLiveSignalsScreenRoute
  '/_app/market/signals/open-trades': typeof screensSignalsOpenTradesScreenRoute
  '/_app/market/signals/trend': typeof screensSignalsTrendSignalsScreenRoute
  '/_app/market/signals/volatile': typeof screensSignalsVolatileStocksScreenRoute
  '/_app/mutual-funds/fund/$symbol': typeof screensMutualFundsFundScreenRoute
  '/_app/portfolio/add/ai': typeof screensPortfolioAddWithMitraScreenRoute
  '/_app/courses/$courseId/lectures/$lectureId': typeof screensCoursesLectureScreenRoute
  '/_app/market/signals/stock/$symbol': typeof screensSignalsSignalStockScreenRoute
  '/_app/market/signals/stock/$symbol/technicals': typeof screensSignalsSignalTechnicalsScreenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/welcome'
    | '/alerts'
    | '/baskets'
    | '/brokers'
    | '/chat'
    | '/companies'
    | '/courses'
    | '/dashboards'
    | '/issues'
    | '/market'
    | '/mutual-funds'
    | '/newsletters'
    | '/notifications'
    | '/portfolio'
    | '/profile'
    | '/screener'
    | '/settings'
    | '/subscription'
    | '/watchlist'
    | '/forgot-password'
    | '/signin'
    | '/signup'
    | '/verify'
    | '/chart'
    | '/onboarding/done'
    | '/onboarding/persona'
    | '/onboarding/plan'
    | '/baskets/$basketId'
    | '/brokers/$code'
    | '/brokers/all'
    | '/brokers/by-broker'
    | '/brokers/by-stock'
    | '/brokers/compare'
    | '/brokers/large-holdings'
    | '/brokers/large-trades'
    | '/brokers/last-minute'
    | '/brokers/most-traded'
    | '/brokers/pv-range'
    | '/brokers/reviews'
    | '/brokers/sector-flow'
    | '/courses/$courseId'
    | '/courses/certificates'
    | '/courses/faq'
    | '/courses/my-learning'
    | '/courses/path'
    | '/dashboards/$dashboardId'
    | '/dev/components'
    | '/ipo/$key'
    | '/learn/dictionary'
    | '/market/52-week'
    | '/market/depth'
    | '/market/events'
    | '/market/floorsheet'
    | '/market/gainers-losers'
    | '/market/heatmap'
    | '/market/indices'
    | '/market/issues'
    | '/market/live'
    | '/market/movers'
    | '/market/news'
    | '/market/newsletters'
    | '/market/prices'
    | '/market/sectors'
    | '/market/signals'
    | '/market/stock-prices'
    | '/market/stock-trading'
    | '/market/trading-average'
    | '/market/update'
    | '/mutual-funds/dividends'
    | '/mutual-funds/industry-holdings'
    | '/mutual-funds/monthly-holdings'
    | '/mutual-funds/price-vs-nav'
    | '/mutual-funds/rankings'
    | '/newsletters/$issueNumber'
    | '/payment/failed'
    | '/payment/return'
    | '/portfolio/activity'
    | '/portfolio/allocation'
    | '/portfolio/analytics'
    | '/portfolio/dashboard'
    | '/portfolio/health'
    | '/portfolio/holdings'
    | '/portfolio/import'
    | '/portfolio/income'
    | '/posts/$postId'
    | '/screener/advanced'
    | '/stocks/$symbol'
    | '/subscription/billing'
    | '/subscription/checkout'
    | '/subscription/manage'
    | '/verify/$code'
    | '/chart/$symbol'
    | '/brokers/$code/reviews'
    | '/brokers/by-stock/$symbol'
    | '/brokers/pv-range/$symbol'
    | '/courses/$courseId/checkout'
    | '/courses/path/$stepId'
    | '/learn/dictionary/$slug'
    | '/market/news/article'
    | '/market/newsletters/$issueNumber'
    | '/market/signals/breakouts'
    | '/market/signals/cycle-map'
    | '/market/signals/daily'
    | '/market/signals/essentials'
    | '/market/signals/history'
    | '/market/signals/live'
    | '/market/signals/open-trades'
    | '/market/signals/trend'
    | '/market/signals/volatile'
    | '/mutual-funds/fund/$symbol'
    | '/portfolio/add/ai'
    | '/courses/$courseId/lectures/$lectureId'
    | '/market/signals/stock/$symbol'
    | '/market/signals/stock/$symbol/technicals'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/welcome'
    | '/alerts'
    | '/baskets'
    | '/brokers'
    | '/chat'
    | '/companies'
    | '/courses'
    | '/dashboards'
    | '/issues'
    | '/market'
    | '/mutual-funds'
    | '/newsletters'
    | '/notifications'
    | '/portfolio'
    | '/profile'
    | '/screener'
    | '/settings'
    | '/subscription'
    | '/watchlist'
    | '/forgot-password'
    | '/signin'
    | '/signup'
    | '/verify'
    | '/chart'
    | '/onboarding/done'
    | '/onboarding/persona'
    | '/onboarding/plan'
    | '/baskets/$basketId'
    | '/brokers/$code'
    | '/brokers/all'
    | '/brokers/by-broker'
    | '/brokers/by-stock'
    | '/brokers/compare'
    | '/brokers/large-holdings'
    | '/brokers/large-trades'
    | '/brokers/last-minute'
    | '/brokers/most-traded'
    | '/brokers/pv-range'
    | '/brokers/reviews'
    | '/brokers/sector-flow'
    | '/courses/$courseId'
    | '/courses/certificates'
    | '/courses/faq'
    | '/courses/my-learning'
    | '/courses/path'
    | '/dashboards/$dashboardId'
    | '/dev/components'
    | '/ipo/$key'
    | '/learn/dictionary'
    | '/market/52-week'
    | '/market/depth'
    | '/market/events'
    | '/market/floorsheet'
    | '/market/gainers-losers'
    | '/market/heatmap'
    | '/market/indices'
    | '/market/issues'
    | '/market/live'
    | '/market/movers'
    | '/market/news'
    | '/market/newsletters'
    | '/market/prices'
    | '/market/sectors'
    | '/market/signals'
    | '/market/stock-prices'
    | '/market/stock-trading'
    | '/market/trading-average'
    | '/market/update'
    | '/mutual-funds/dividends'
    | '/mutual-funds/industry-holdings'
    | '/mutual-funds/monthly-holdings'
    | '/mutual-funds/price-vs-nav'
    | '/mutual-funds/rankings'
    | '/newsletters/$issueNumber'
    | '/payment/failed'
    | '/payment/return'
    | '/portfolio/activity'
    | '/portfolio/allocation'
    | '/portfolio/analytics'
    | '/portfolio/dashboard'
    | '/portfolio/health'
    | '/portfolio/holdings'
    | '/portfolio/import'
    | '/portfolio/income'
    | '/posts/$postId'
    | '/screener/advanced'
    | '/stocks/$symbol'
    | '/subscription/billing'
    | '/subscription/checkout'
    | '/subscription/manage'
    | '/verify/$code'
    | '/chart/$symbol'
    | '/brokers/$code/reviews'
    | '/brokers/by-stock/$symbol'
    | '/brokers/pv-range/$symbol'
    | '/courses/$courseId/checkout'
    | '/courses/path/$stepId'
    | '/learn/dictionary/$slug'
    | '/market/news/article'
    | '/market/newsletters/$issueNumber'
    | '/market/signals/breakouts'
    | '/market/signals/cycle-map'
    | '/market/signals/daily'
    | '/market/signals/essentials'
    | '/market/signals/history'
    | '/market/signals/live'
    | '/market/signals/open-trades'
    | '/market/signals/trend'
    | '/market/signals/volatile'
    | '/mutual-funds/fund/$symbol'
    | '/portfolio/add/ai'
    | '/courses/$courseId/lectures/$lectureId'
    | '/market/signals/stock/$symbol'
    | '/market/signals/stock/$symbol/technicals'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/_public'
    | '/_workspace'
    | '/welcome'
    | '/_app/'
    | '/_app/alerts'
    | '/_app/baskets'
    | '/_app/brokers'
    | '/_app/chat'
    | '/_app/companies'
    | '/_app/courses'
    | '/_app/dashboards'
    | '/_app/issues'
    | '/_app/market'
    | '/_app/mutual-funds'
    | '/_app/newsletters'
    | '/_app/notifications'
    | '/_app/portfolio'
    | '/_app/profile'
    | '/_app/screener'
    | '/_app/settings'
    | '/_app/subscription'
    | '/_app/watchlist'
    | '/_auth/forgot-password'
    | '/_auth/signin'
    | '/_auth/signup'
    | '/_auth/verify'
    | '/_workspace/chart'
    | '/onboarding/done'
    | '/onboarding/persona'
    | '/onboarding/plan'
    | '/_app/baskets/$basketId'
    | '/_app/brokers/$code'
    | '/_app/brokers/all'
    | '/_app/brokers/by-broker'
    | '/_app/brokers/by-stock'
    | '/_app/brokers/compare'
    | '/_app/brokers/large-holdings'
    | '/_app/brokers/large-trades'
    | '/_app/brokers/last-minute'
    | '/_app/brokers/most-traded'
    | '/_app/brokers/pv-range'
    | '/_app/brokers/reviews'
    | '/_app/brokers/sector-flow'
    | '/_app/courses/$courseId'
    | '/_app/courses/certificates'
    | '/_app/courses/faq'
    | '/_app/courses/my-learning'
    | '/_app/courses/path'
    | '/_app/dashboards/$dashboardId'
    | '/_app/dev/components'
    | '/_app/ipo/$key'
    | '/_app/learn/dictionary'
    | '/_app/market/52-week'
    | '/_app/market/depth'
    | '/_app/market/events'
    | '/_app/market/floorsheet'
    | '/_app/market/gainers-losers'
    | '/_app/market/heatmap'
    | '/_app/market/indices'
    | '/_app/market/issues'
    | '/_app/market/live'
    | '/_app/market/movers'
    | '/_app/market/news'
    | '/_app/market/newsletters'
    | '/_app/market/prices'
    | '/_app/market/sectors'
    | '/_app/market/signals'
    | '/_app/market/stock-prices'
    | '/_app/market/stock-trading'
    | '/_app/market/trading-average'
    | '/_app/market/update'
    | '/_app/mutual-funds/dividends'
    | '/_app/mutual-funds/industry-holdings'
    | '/_app/mutual-funds/monthly-holdings'
    | '/_app/mutual-funds/price-vs-nav'
    | '/_app/mutual-funds/rankings'
    | '/_app/newsletters/$issueNumber'
    | '/_app/payment/failed'
    | '/_app/payment/return'
    | '/_app/portfolio/activity'
    | '/_app/portfolio/allocation'
    | '/_app/portfolio/analytics'
    | '/_app/portfolio/dashboard'
    | '/_app/portfolio/health'
    | '/_app/portfolio/holdings'
    | '/_app/portfolio/import'
    | '/_app/portfolio/income'
    | '/_app/posts/$postId'
    | '/_app/screener/advanced'
    | '/_app/stocks/$symbol'
    | '/_app/subscription/billing'
    | '/_app/subscription/checkout'
    | '/_app/subscription/manage'
    | '/_public/verify/$code'
    | '/_workspace/chart/$symbol'
    | '/_app/brokers/$code/reviews'
    | '/_app/brokers/by-stock/$symbol'
    | '/_app/brokers/pv-range/$symbol'
    | '/_app/courses/$courseId/checkout'
    | '/_app/courses/path/$stepId'
    | '/_app/learn/dictionary/$slug'
    | '/_app/market/news/article'
    | '/_app/market/newsletters/$issueNumber'
    | '/_app/market/signals/breakouts'
    | '/_app/market/signals/cycle-map'
    | '/_app/market/signals/daily'
    | '/_app/market/signals/essentials'
    | '/_app/market/signals/history'
    | '/_app/market/signals/live'
    | '/_app/market/signals/open-trades'
    | '/_app/market/signals/trend'
    | '/_app/market/signals/volatile'
    | '/_app/mutual-funds/fund/$symbol'
    | '/_app/portfolio/add/ai'
    | '/_app/courses/$courseId/lectures/$lectureId'
    | '/_app/market/signals/stock/$symbol'
    | '/_app/market/signals/stock/$symbol/technicals'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  routesLayoutsAppRoute: typeof routesLayoutsAppRouteWithChildren
  routesLayoutsAuthRoute: typeof routesLayoutsAuthRouteWithChildren
  routesLayoutsPublicRoute: typeof routesLayoutsPublicRouteWithChildren
  routesLayoutsWorkspaceRoute: typeof routesLayoutsWorkspaceRouteWithChildren
  screensOnboardingWelcomeScreenRoute: typeof screensOnboardingWelcomeScreenRoute
  screensOnboardingAllDoneScreenRoute: typeof screensOnboardingAllDoneScreenRoute
  screensOnboardingWhosClosestScreenRoute: typeof screensOnboardingWhosClosestScreenRoute
  screensOnboardingPickPlanScreenRoute: typeof screensOnboardingPickPlanScreenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof routesLayoutsAppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof routesLayoutsAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof routesLayoutsPublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_workspace': {
      id: '/_workspace'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof routesLayoutsWorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof screensOnboardingWelcomeScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof screensAppHomeScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/alerts': {
      id: '/_app/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof screensAppAlertsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/baskets': {
      id: '/_app/baskets'
      path: '/baskets'
      fullPath: '/baskets'
      preLoaderRoute: typeof screensBasketsBasketsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/brokers': {
      id: '/_app/brokers'
      path: '/brokers'
      fullPath: '/brokers'
      preLoaderRoute: typeof screensBrokersOverviewScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/chat': {
      id: '/_app/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof screensAppChatScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/companies': {
      id: '/_app/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof screensAppCompaniesScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/courses': {
      id: '/_app/courses'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof screensCoursesCoursesScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/dashboards': {
      id: '/_app/dashboards'
      path: '/dashboards'
      fullPath: '/dashboards'
      preLoaderRoute: typeof screensDashboardsDashboardsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/issues': {
      id: '/_app/issues'
      path: '/issues'
      fullPath: '/issues'
      preLoaderRoute: typeof screensIpoIssuesRedirectRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market': {
      id: '/_app/market'
      path: '/market'
      fullPath: '/market'
      preLoaderRoute: typeof screensMarketOverviewScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/mutual-funds': {
      id: '/_app/mutual-funds'
      path: '/mutual-funds'
      fullPath: '/mutual-funds'
      preLoaderRoute: typeof screensMutualFundsAnalyticsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/newsletters': {
      id: '/_app/newsletters'
      path: '/newsletters'
      fullPath: '/newsletters'
      preLoaderRoute: typeof screensNewsletterNewslettersRedirectRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof screensAppNotificationsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/portfolio': {
      id: '/_app/portfolio'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof screensPortfolioOverviewScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof screensAccountProfileScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/screener': {
      id: '/_app/screener'
      path: '/screener'
      fullPath: '/screener'
      preLoaderRoute: typeof screensScreenerScreenerRedirectRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof screensAccountSettingsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/subscription': {
      id: '/_app/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof screensAccountSubscriptionScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/watchlist': {
      id: '/_app/watchlist'
      path: '/watchlist'
      fullPath: '/watchlist'
      preLoaderRoute: typeof screensAppWatchlistScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof screensAuthForgotPasswordScreenRouteImport
      parentRoute: typeof routesLayoutsAuthRoute
    }
    '/_auth/signin': {
      id: '/_auth/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof screensAuthSignInScreenRouteImport
      parentRoute: typeof routesLayoutsAuthRoute
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof screensAuthSignUpScreenRouteImport
      parentRoute: typeof routesLayoutsAuthRoute
    }
    '/_auth/verify': {
      id: '/_auth/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof screensAuthVerifyScreenRouteImport
      parentRoute: typeof routesLayoutsAuthRoute
    }
    '/_workspace/chart': {
      id: '/_workspace/chart'
      path: '/chart'
      fullPath: '/chart'
      preLoaderRoute: typeof screensChartChartRedirectRouteImport
      parentRoute: typeof routesLayoutsWorkspaceRoute
    }
    '/onboarding/done': {
      id: '/onboarding/done'
      path: '/onboarding/done'
      fullPath: '/onboarding/done'
      preLoaderRoute: typeof screensOnboardingAllDoneScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/persona': {
      id: '/onboarding/persona'
      path: '/onboarding/persona'
      fullPath: '/onboarding/persona'
      preLoaderRoute: typeof screensOnboardingWhosClosestScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/plan': {
      id: '/onboarding/plan'
      path: '/onboarding/plan'
      fullPath: '/onboarding/plan'
      preLoaderRoute: typeof screensOnboardingPickPlanScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/baskets/$basketId': {
      id: '/_app/baskets/$basketId'
      path: '/baskets/$basketId'
      fullPath: '/baskets/$basketId'
      preLoaderRoute: typeof screensBasketsBasketDetailScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/brokers/$code': {
      id: '/_app/brokers/$code'
      path: '/brokers/$code'
      fullPath: '/brokers/$code'
      preLoaderRoute: typeof screensBrokersBrokerScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/brokers/all': {
      id: '/_app/brokers/all'
      path: '/brokers/all'
      fullPath: '/brokers/all'
      preLoaderRoute: typeof screensBrokersAllBrokersScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/brokers/by-broker': {
      id: '/_app/brokers/by-broker'
      path: '/brokers/by-broker'
      fullPath: '/brokers/by-broker'
      preLoaderRoute: typeof screensBrokersByBrokerRedirectRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/brokers/by-stock': {
      id: '/_app/brokers/by-stock'
      path: '/brokers/by-stock'
      fullPath: '/brokers/by-stock'
      preLoaderRoute: typeof screensBrokersByStockRedirectRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/brokers/compare': {
      id: '/_app/brokers/compare'
      path: '/brokers/compare'
      fullPath: '/brokers/compare'
      preLoaderRoute: typeof screensBrokersCompareScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/brokers/large-holdings': {
      id: '/_app/brokers/large-holdings'
      path: '/brokers/large-holdings'
      fullPath: '/brokers/large-holdings'
      preLoaderRoute: typeof screensBrokersLargeHoldingsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/brokers/large-trades': {
      id: '/_app/brokers/large-trades'
      path: '/brokers/large-trades'
      fullPath: '/brokers/large-trades'
      preLoaderRoute: typeof screensBrokersLargeTradesScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/brokers/last-minute': {
      id: '/_app/brokers/last-minute'
      path: '/brokers/last-minute'
      fullPath: '/brokers/last-minute'
      preLoaderRoute: typeof screensBrokersLastMinuteScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/brokers/most-traded': {
      id: '/_app/brokers/most-traded'
      path: '/brokers/most-traded'
      fullPath: '/brokers/most-traded'
      preLoaderRoute: typeof screensBrokersMostTradedScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/brokers/pv-range': {
      id: '/_app/brokers/pv-range'
      path: '/brokers/pv-range'
      fullPath: '/brokers/pv-range'
      preLoaderRoute: typeof screensBrokersPVRangeRedirectRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/brokers/reviews': {
      id: '/_app/brokers/reviews'
      path: '/brokers/reviews'
      fullPath: '/brokers/reviews'
      preLoaderRoute: typeof screensBrokersReviewsRedirectRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/brokers/sector-flow': {
      id: '/_app/brokers/sector-flow'
      path: '/brokers/sector-flow'
      fullPath: '/brokers/sector-flow'
      preLoaderRoute: typeof screensBrokersSectorFlowScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/courses/$courseId': {
      id: '/_app/courses/$courseId'
      path: '/courses/$courseId'
      fullPath: '/courses/$courseId'
      preLoaderRoute: typeof screensCoursesCourseDetailScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/courses/certificates': {
      id: '/_app/courses/certificates'
      path: '/courses/certificates'
      fullPath: '/courses/certificates'
      preLoaderRoute: typeof screensCoursesCertificatesScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/courses/faq': {
      id: '/_app/courses/faq'
      path: '/courses/faq'
      fullPath: '/courses/faq'
      preLoaderRoute: typeof screensCoursesFaqScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/courses/my-learning': {
      id: '/_app/courses/my-learning'
      path: '/courses/my-learning'
      fullPath: '/courses/my-learning'
      preLoaderRoute: typeof screensCoursesMyLearningScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/courses/path': {
      id: '/_app/courses/path'
      path: '/courses/path'
      fullPath: '/courses/path'
      preLoaderRoute: typeof screensCoursesLearningPathScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/dashboards/$dashboardId': {
      id: '/_app/dashboards/$dashboardId'
      path: '/dashboards/$dashboardId'
      fullPath: '/dashboards/$dashboardId'
      preLoaderRoute: typeof screensDashboardsDashboardScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/dev/components': {
      id: '/_app/dev/components'
      path: '/dev/components'
      fullPath: '/dev/components'
      preLoaderRoute: typeof screensDevComponentGalleryScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/ipo/$key': {
      id: '/_app/ipo/$key'
      path: '/ipo/$key'
      fullPath: '/ipo/$key'
      preLoaderRoute: typeof screensIpoIpoScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/learn/dictionary': {
      id: '/_app/learn/dictionary'
      path: '/learn/dictionary'
      fullPath: '/learn/dictionary'
      preLoaderRoute: typeof screensCoursesDictionaryScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/52-week': {
      id: '/_app/market/52-week'
      path: '/market/52-week'
      fullPath: '/market/52-week'
      preLoaderRoute: typeof screensMarketWeek52ScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/depth': {
      id: '/_app/market/depth'
      path: '/market/depth'
      fullPath: '/market/depth'
      preLoaderRoute: typeof screensMarketDepthScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/events': {
      id: '/_app/market/events'
      path: '/market/events'
      fullPath: '/market/events'
      preLoaderRoute: typeof screensMarketEventsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/floorsheet': {
      id: '/_app/market/floorsheet'
      path: '/market/floorsheet'
      fullPath: '/market/floorsheet'
      preLoaderRoute: typeof screensMarketFloorsheetScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/gainers-losers': {
      id: '/_app/market/gainers-losers'
      path: '/market/gainers-losers'
      fullPath: '/market/gainers-losers'
      preLoaderRoute: typeof screensMarketGainersLosersScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/heatmap': {
      id: '/_app/market/heatmap'
      path: '/market/heatmap'
      fullPath: '/market/heatmap'
      preLoaderRoute: typeof screensMarketHeatmapScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/indices': {
      id: '/_app/market/indices'
      path: '/market/indices'
      fullPath: '/market/indices'
      preLoaderRoute: typeof screensMarketIndicesScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/issues': {
      id: '/_app/market/issues'
      path: '/market/issues'
      fullPath: '/market/issues'
      preLoaderRoute: typeof screensIpoPublicIssuesScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/live': {
      id: '/_app/market/live'
      path: '/market/live'
      fullPath: '/market/live'
      preLoaderRoute: typeof screensMarketLiveMarketScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/movers': {
      id: '/_app/market/movers'
      path: '/market/movers'
      fullPath: '/market/movers'
      preLoaderRoute: typeof screensMarketMoversScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/news': {
      id: '/_app/market/news'
      path: '/market/news'
      fullPath: '/market/news'
      preLoaderRoute: typeof screensMarketMarketNewsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/newsletters': {
      id: '/_app/market/newsletters'
      path: '/market/newsletters'
      fullPath: '/market/newsletters'
      preLoaderRoute: typeof screensNewsletterNewslettersScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/prices': {
      id: '/_app/market/prices'
      path: '/market/prices'
      fullPath: '/market/prices'
      preLoaderRoute: typeof screensMarketStockPricesRedirectRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/sectors': {
      id: '/_app/market/sectors'
      path: '/market/sectors'
      fullPath: '/market/sectors'
      preLoaderRoute: typeof screensMarketSectorsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/signals': {
      id: '/_app/market/signals'
      path: '/market/signals'
      fullPath: '/market/signals'
      preLoaderRoute: typeof screensSignalsSignalZoneScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/stock-prices': {
      id: '/_app/market/stock-prices'
      path: '/market/stock-prices'
      fullPath: '/market/stock-prices'
      preLoaderRoute: typeof screensMarketStockPricesScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/stock-trading': {
      id: '/_app/market/stock-trading'
      path: '/market/stock-trading'
      fullPath: '/market/stock-trading'
      preLoaderRoute: typeof screensMarketStockTradingScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/trading-average': {
      id: '/_app/market/trading-average'
      path: '/market/trading-average'
      fullPath: '/market/trading-average'
      preLoaderRoute: typeof screensMarketTradingAverageScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/update': {
      id: '/_app/market/update'
      path: '/market/update'
      fullPath: '/market/update'
      preLoaderRoute: typeof screensMarketMarketUpdateScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/mutual-funds/dividends': {
      id: '/_app/mutual-funds/dividends'
      path: '/mutual-funds/dividends'
      fullPath: '/mutual-funds/dividends'
      preLoaderRoute: typeof screensMutualFundsDividendsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/mutual-funds/industry-holdings': {
      id: '/_app/mutual-funds/industry-holdings'
      path: '/mutual-funds/industry-holdings'
      fullPath: '/mutual-funds/industry-holdings'
      preLoaderRoute: typeof screensMutualFundsIndustryHoldingsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/mutual-funds/monthly-holdings': {
      id: '/_app/mutual-funds/monthly-holdings'
      path: '/mutual-funds/monthly-holdings'
      fullPath: '/mutual-funds/monthly-holdings'
      preLoaderRoute: typeof screensMutualFundsMonthlyHoldingsRedirectRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/mutual-funds/price-vs-nav': {
      id: '/_app/mutual-funds/price-vs-nav'
      path: '/mutual-funds/price-vs-nav'
      fullPath: '/mutual-funds/price-vs-nav'
      preLoaderRoute: typeof screensMutualFundsPriceVsNavScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/mutual-funds/rankings': {
      id: '/_app/mutual-funds/rankings'
      path: '/mutual-funds/rankings'
      fullPath: '/mutual-funds/rankings'
      preLoaderRoute: typeof screensMutualFundsRankingsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/newsletters/$issueNumber': {
      id: '/_app/newsletters/$issueNumber'
      path: '/newsletters/$issueNumber'
      fullPath: '/newsletters/$issueNumber'
      preLoaderRoute: typeof screensNewsletterNewsletterIssueRedirectRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/payment/failed': {
      id: '/_app/payment/failed'
      path: '/payment/failed'
      fullPath: '/payment/failed'
      preLoaderRoute: typeof screensAccountPaymentFailedScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/payment/return': {
      id: '/_app/payment/return'
      path: '/payment/return'
      fullPath: '/payment/return'
      preLoaderRoute: typeof screensAccountPaymentReturnScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/portfolio/activity': {
      id: '/_app/portfolio/activity'
      path: '/portfolio/activity'
      fullPath: '/portfolio/activity'
      preLoaderRoute: typeof screensPortfolioActivityScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/portfolio/allocation': {
      id: '/_app/portfolio/allocation'
      path: '/portfolio/allocation'
      fullPath: '/portfolio/allocation'
      preLoaderRoute: typeof screensPortfolioAllocationScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/portfolio/analytics': {
      id: '/_app/portfolio/analytics'
      path: '/portfolio/analytics'
      fullPath: '/portfolio/analytics'
      preLoaderRoute: typeof screensPortfolioAnalyticsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/portfolio/dashboard': {
      id: '/_app/portfolio/dashboard'
      path: '/portfolio/dashboard'
      fullPath: '/portfolio/dashboard'
      preLoaderRoute: typeof screensPortfolioDashboardRedirectRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/portfolio/health': {
      id: '/_app/portfolio/health'
      path: '/portfolio/health'
      fullPath: '/portfolio/health'
      preLoaderRoute: typeof screensPortfolioHealthScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/portfolio/holdings': {
      id: '/_app/portfolio/holdings'
      path: '/portfolio/holdings'
      fullPath: '/portfolio/holdings'
      preLoaderRoute: typeof screensPortfolioHoldingsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/portfolio/import': {
      id: '/_app/portfolio/import'
      path: '/portfolio/import'
      fullPath: '/portfolio/import'
      preLoaderRoute: typeof screensPortfolioImportPortfolioScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/portfolio/income': {
      id: '/_app/portfolio/income'
      path: '/portfolio/income'
      fullPath: '/portfolio/income'
      preLoaderRoute: typeof screensPortfolioIncomeScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/posts/$postId': {
      id: '/_app/posts/$postId'
      path: '/posts/$postId'
      fullPath: '/posts/$postId'
      preLoaderRoute: typeof screensPostsPostScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/screener/advanced': {
      id: '/_app/screener/advanced'
      path: '/screener/advanced'
      fullPath: '/screener/advanced'
      preLoaderRoute: typeof screensScreenerAdvancedScreenerScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/stocks/$symbol': {
      id: '/_app/stocks/$symbol'
      path: '/stocks/$symbol'
      fullPath: '/stocks/$symbol'
      preLoaderRoute: typeof screensStockStockScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/subscription/billing': {
      id: '/_app/subscription/billing'
      path: '/subscription/billing'
      fullPath: '/subscription/billing'
      preLoaderRoute: typeof screensAccountBillingHistoryScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/subscription/checkout': {
      id: '/_app/subscription/checkout'
      path: '/subscription/checkout'
      fullPath: '/subscription/checkout'
      preLoaderRoute: typeof screensAccountCheckoutScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/subscription/manage': {
      id: '/_app/subscription/manage'
      path: '/subscription/manage'
      fullPath: '/subscription/manage'
      preLoaderRoute: typeof screensAccountManagePlanScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_public/verify/$code': {
      id: '/_public/verify/$code'
      path: '/verify/$code'
      fullPath: '/verify/$code'
      preLoaderRoute: typeof screensCoursesVerifyCertificateScreenRouteImport
      parentRoute: typeof routesLayoutsPublicRoute
    }
    '/_workspace/chart/$symbol': {
      id: '/_workspace/chart/$symbol'
      path: '/chart/$symbol'
      fullPath: '/chart/$symbol'
      preLoaderRoute: typeof screensChartChartScreenRouteImport
      parentRoute: typeof routesLayoutsWorkspaceRoute
    }
    '/_app/brokers/$code/reviews': {
      id: '/_app/brokers/$code/reviews'
      path: '/brokers/$code/reviews'
      fullPath: '/brokers/$code/reviews'
      preLoaderRoute: typeof screensBrokersBrokerReviewsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/brokers/by-stock/$symbol': {
      id: '/_app/brokers/by-stock/$symbol'
      path: '/brokers/by-stock/$symbol'
      fullPath: '/brokers/by-stock/$symbol'
      preLoaderRoute: typeof screensBrokersByStockScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/brokers/pv-range/$symbol': {
      id: '/_app/brokers/pv-range/$symbol'
      path: '/brokers/pv-range/$symbol'
      fullPath: '/brokers/pv-range/$symbol'
      preLoaderRoute: typeof screensBrokersPVRangeScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/courses/$courseId/checkout': {
      id: '/_app/courses/$courseId/checkout'
      path: '/courses/$courseId/checkout'
      fullPath: '/courses/$courseId/checkout'
      preLoaderRoute: typeof screensCoursesCourseCheckoutScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/courses/path/$stepId': {
      id: '/_app/courses/path/$stepId'
      path: '/courses/path/$stepId'
      fullPath: '/courses/path/$stepId'
      preLoaderRoute: typeof screensCoursesPathStepScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/learn/dictionary/$slug': {
      id: '/_app/learn/dictionary/$slug'
      path: '/learn/dictionary/$slug'
      fullPath: '/learn/dictionary/$slug'
      preLoaderRoute: typeof screensCoursesDictionaryTermScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/news/article': {
      id: '/_app/market/news/article'
      path: '/market/news/article'
      fullPath: '/market/news/article'
      preLoaderRoute: typeof screensMarketNewsArticleScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/newsletters/$issueNumber': {
      id: '/_app/market/newsletters/$issueNumber'
      path: '/market/newsletters/$issueNumber'
      fullPath: '/market/newsletters/$issueNumber'
      preLoaderRoute: typeof screensNewsletterNewsletterIssueScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/signals/breakouts': {
      id: '/_app/market/signals/breakouts'
      path: '/market/signals/breakouts'
      fullPath: '/market/signals/breakouts'
      preLoaderRoute: typeof screensSignalsBreakoutsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/signals/cycle-map': {
      id: '/_app/market/signals/cycle-map'
      path: '/market/signals/cycle-map'
      fullPath: '/market/signals/cycle-map'
      preLoaderRoute: typeof screensSignalsCycleMapScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/signals/daily': {
      id: '/_app/market/signals/daily'
      path: '/market/signals/daily'
      fullPath: '/market/signals/daily'
      preLoaderRoute: typeof screensSignalsDailyForecastScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/signals/essentials': {
      id: '/_app/market/signals/essentials'
      path: '/market/signals/essentials'
      fullPath: '/market/signals/essentials'
      preLoaderRoute: typeof screensSignalsEssentialsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/signals/history': {
      id: '/_app/market/signals/history'
      path: '/market/signals/history'
      fullPath: '/market/signals/history'
      preLoaderRoute: typeof screensSignalsSignalHistoryScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/signals/live': {
      id: '/_app/market/signals/live'
      path: '/market/signals/live'
      fullPath: '/market/signals/live'
      preLoaderRoute: typeof screensSignalsLiveSignalsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/signals/open-trades': {
      id: '/_app/market/signals/open-trades'
      path: '/market/signals/open-trades'
      fullPath: '/market/signals/open-trades'
      preLoaderRoute: typeof screensSignalsOpenTradesScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/signals/trend': {
      id: '/_app/market/signals/trend'
      path: '/market/signals/trend'
      fullPath: '/market/signals/trend'
      preLoaderRoute: typeof screensSignalsTrendSignalsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/signals/volatile': {
      id: '/_app/market/signals/volatile'
      path: '/market/signals/volatile'
      fullPath: '/market/signals/volatile'
      preLoaderRoute: typeof screensSignalsVolatileStocksScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/mutual-funds/fund/$symbol': {
      id: '/_app/mutual-funds/fund/$symbol'
      path: '/mutual-funds/fund/$symbol'
      fullPath: '/mutual-funds/fund/$symbol'
      preLoaderRoute: typeof screensMutualFundsFundScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/portfolio/add/ai': {
      id: '/_app/portfolio/add/ai'
      path: '/portfolio/add/ai'
      fullPath: '/portfolio/add/ai'
      preLoaderRoute: typeof screensPortfolioAddWithMitraScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/courses/$courseId/lectures/$lectureId': {
      id: '/_app/courses/$courseId/lectures/$lectureId'
      path: '/courses/$courseId/lectures/$lectureId'
      fullPath: '/courses/$courseId/lectures/$lectureId'
      preLoaderRoute: typeof screensCoursesLectureScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/signals/stock/$symbol': {
      id: '/_app/market/signals/stock/$symbol'
      path: '/market/signals/stock/$symbol'
      fullPath: '/market/signals/stock/$symbol'
      preLoaderRoute: typeof screensSignalsSignalStockScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
    '/_app/market/signals/stock/$symbol/technicals': {
      id: '/_app/market/signals/stock/$symbol/technicals'
      path: '/market/signals/stock/$symbol/technicals'
      fullPath: '/market/signals/stock/$symbol/technicals'
      preLoaderRoute: typeof screensSignalsSignalTechnicalsScreenRouteImport
      parentRoute: typeof routesLayoutsAppRoute
    }
  }
}

interface routesLayoutsAppRouteChildren {
  screensAppHomeScreenRoute: typeof screensAppHomeScreenRoute
  screensAppAlertsScreenRoute: typeof screensAppAlertsScreenRoute
  screensBasketsBasketsScreenRoute: typeof screensBasketsBasketsScreenRoute
  screensBrokersOverviewScreenRoute: typeof screensBrokersOverviewScreenRoute
  screensAppChatScreenRoute: typeof screensAppChatScreenRoute
  screensAppCompaniesScreenRoute: typeof screensAppCompaniesScreenRoute
  screensCoursesCoursesScreenRoute: typeof screensCoursesCoursesScreenRoute
  screensDashboardsDashboardsScreenRoute: typeof screensDashboardsDashboardsScreenRoute
  screensIpoIssuesRedirectRoute: typeof screensIpoIssuesRedirectRoute
  screensMarketOverviewScreenRoute: typeof screensMarketOverviewScreenRoute
  screensMutualFundsAnalyticsScreenRoute: typeof screensMutualFundsAnalyticsScreenRoute
  screensNewsletterNewslettersRedirectRoute: typeof screensNewsletterNewslettersRedirectRoute
  screensAppNotificationsScreenRoute: typeof screensAppNotificationsScreenRoute
  screensPortfolioOverviewScreenRoute: typeof screensPortfolioOverviewScreenRoute
  screensAccountProfileScreenRoute: typeof screensAccountProfileScreenRoute
  screensScreenerScreenerRedirectRoute: typeof screensScreenerScreenerRedirectRoute
  screensAccountSettingsScreenRoute: typeof screensAccountSettingsScreenRoute
  screensAccountSubscriptionScreenRoute: typeof screensAccountSubscriptionScreenRoute
  screensAppWatchlistScreenRoute: typeof screensAppWatchlistScreenRoute
  screensBasketsBasketDetailScreenRoute: typeof screensBasketsBasketDetailScreenRoute
  screensBrokersBrokerScreenRoute: typeof screensBrokersBrokerScreenRoute
  screensBrokersAllBrokersScreenRoute: typeof screensBrokersAllBrokersScreenRoute
  screensBrokersByBrokerRedirectRoute: typeof screensBrokersByBrokerRedirectRoute
  screensBrokersByStockRedirectRoute: typeof screensBrokersByStockRedirectRoute
  screensBrokersCompareScreenRoute: typeof screensBrokersCompareScreenRoute
  screensBrokersLargeHoldingsScreenRoute: typeof screensBrokersLargeHoldingsScreenRoute
  screensBrokersLargeTradesScreenRoute: typeof screensBrokersLargeTradesScreenRoute
  screensBrokersLastMinuteScreenRoute: typeof screensBrokersLastMinuteScreenRoute
  screensBrokersMostTradedScreenRoute: typeof screensBrokersMostTradedScreenRoute
  screensBrokersPVRangeRedirectRoute: typeof screensBrokersPVRangeRedirectRoute
  screensBrokersReviewsRedirectRoute: typeof screensBrokersReviewsRedirectRoute
  screensBrokersSectorFlowScreenRoute: typeof screensBrokersSectorFlowScreenRoute
  screensCoursesCourseDetailScreenRoute: typeof screensCoursesCourseDetailScreenRoute
  screensCoursesCertificatesScreenRoute: typeof screensCoursesCertificatesScreenRoute
  screensCoursesFaqScreenRoute: typeof screensCoursesFaqScreenRoute
  screensCoursesMyLearningScreenRoute: typeof screensCoursesMyLearningScreenRoute
  screensCoursesLearningPathScreenRoute: typeof screensCoursesLearningPathScreenRoute
  screensDashboardsDashboardScreenRoute: typeof screensDashboardsDashboardScreenRoute
  screensDevComponentGalleryScreenRoute: typeof screensDevComponentGalleryScreenRoute
  screensIpoIpoScreenRoute: typeof screensIpoIpoScreenRoute
  screensCoursesDictionaryScreenRoute: typeof screensCoursesDictionaryScreenRoute
  screensMarketWeek52ScreenRoute: typeof screensMarketWeek52ScreenRoute
  screensMarketDepthScreenRoute: typeof screensMarketDepthScreenRoute
  screensMarketEventsScreenRoute: typeof screensMarketEventsScreenRoute
  screensMarketFloorsheetScreenRoute: typeof screensMarketFloorsheetScreenRoute
  screensMarketGainersLosersScreenRoute: typeof screensMarketGainersLosersScreenRoute
  screensMarketHeatmapScreenRoute: typeof screensMarketHeatmapScreenRoute
  screensMarketIndicesScreenRoute: typeof screensMarketIndicesScreenRoute
  screensIpoPublicIssuesScreenRoute: typeof screensIpoPublicIssuesScreenRoute
  screensMarketLiveMarketScreenRoute: typeof screensMarketLiveMarketScreenRoute
  screensMarketMoversScreenRoute: typeof screensMarketMoversScreenRoute
  screensMarketMarketNewsScreenRoute: typeof screensMarketMarketNewsScreenRoute
  screensNewsletterNewslettersScreenRoute: typeof screensNewsletterNewslettersScreenRoute
  screensMarketStockPricesRedirectRoute: typeof screensMarketStockPricesRedirectRoute
  screensMarketSectorsScreenRoute: typeof screensMarketSectorsScreenRoute
  screensSignalsSignalZoneScreenRoute: typeof screensSignalsSignalZoneScreenRoute
  screensMarketStockPricesScreenRoute: typeof screensMarketStockPricesScreenRoute
  screensMarketStockTradingScreenRoute: typeof screensMarketStockTradingScreenRoute
  screensMarketTradingAverageScreenRoute: typeof screensMarketTradingAverageScreenRoute
  screensMarketMarketUpdateScreenRoute: typeof screensMarketMarketUpdateScreenRoute
  screensMutualFundsDividendsScreenRoute: typeof screensMutualFundsDividendsScreenRoute
  screensMutualFundsIndustryHoldingsScreenRoute: typeof screensMutualFundsIndustryHoldingsScreenRoute
  screensMutualFundsMonthlyHoldingsRedirectRoute: typeof screensMutualFundsMonthlyHoldingsRedirectRoute
  screensMutualFundsPriceVsNavScreenRoute: typeof screensMutualFundsPriceVsNavScreenRoute
  screensMutualFundsRankingsScreenRoute: typeof screensMutualFundsRankingsScreenRoute
  screensNewsletterNewsletterIssueRedirectRoute: typeof screensNewsletterNewsletterIssueRedirectRoute
  screensAccountPaymentFailedScreenRoute: typeof screensAccountPaymentFailedScreenRoute
  screensAccountPaymentReturnScreenRoute: typeof screensAccountPaymentReturnScreenRoute
  screensPortfolioActivityScreenRoute: typeof screensPortfolioActivityScreenRoute
  screensPortfolioAllocationScreenRoute: typeof screensPortfolioAllocationScreenRoute
  screensPortfolioAnalyticsScreenRoute: typeof screensPortfolioAnalyticsScreenRoute
  screensPortfolioDashboardRedirectRoute: typeof screensPortfolioDashboardRedirectRoute
  screensPortfolioHealthScreenRoute: typeof screensPortfolioHealthScreenRoute
  screensPortfolioHoldingsScreenRoute: typeof screensPortfolioHoldingsScreenRoute
  screensPortfolioImportPortfolioScreenRoute: typeof screensPortfolioImportPortfolioScreenRoute
  screensPortfolioIncomeScreenRoute: typeof screensPortfolioIncomeScreenRoute
  screensPostsPostScreenRoute: typeof screensPostsPostScreenRoute
  screensScreenerAdvancedScreenerScreenRoute: typeof screensScreenerAdvancedScreenerScreenRoute
  screensStockStockScreenRoute: typeof screensStockStockScreenRoute
  screensAccountBillingHistoryScreenRoute: typeof screensAccountBillingHistoryScreenRoute
  screensAccountCheckoutScreenRoute: typeof screensAccountCheckoutScreenRoute
  screensAccountManagePlanScreenRoute: typeof screensAccountManagePlanScreenRoute
  screensBrokersBrokerReviewsScreenRoute: typeof screensBrokersBrokerReviewsScreenRoute
  screensBrokersByStockScreenRoute: typeof screensBrokersByStockScreenRoute
  screensBrokersPVRangeScreenRoute: typeof screensBrokersPVRangeScreenRoute
  screensCoursesCourseCheckoutScreenRoute: typeof screensCoursesCourseCheckoutScreenRoute
  screensCoursesPathStepScreenRoute: typeof screensCoursesPathStepScreenRoute
  screensCoursesDictionaryTermScreenRoute: typeof screensCoursesDictionaryTermScreenRoute
  screensMarketNewsArticleScreenRoute: typeof screensMarketNewsArticleScreenRoute
  screensNewsletterNewsletterIssueScreenRoute: typeof screensNewsletterNewsletterIssueScreenRoute
  screensSignalsBreakoutsScreenRoute: typeof screensSignalsBreakoutsScreenRoute
  screensSignalsCycleMapScreenRoute: typeof screensSignalsCycleMapScreenRoute
  screensSignalsDailyForecastScreenRoute: typeof screensSignalsDailyForecastScreenRoute
  screensSignalsEssentialsScreenRoute: typeof screensSignalsEssentialsScreenRoute
  screensSignalsSignalHistoryScreenRoute: typeof screensSignalsSignalHistoryScreenRoute
  screensSignalsLiveSignalsScreenRoute: typeof screensSignalsLiveSignalsScreenRoute
  screensSignalsOpenTradesScreenRoute: typeof screensSignalsOpenTradesScreenRoute
  screensSignalsTrendSignalsScreenRoute: typeof screensSignalsTrendSignalsScreenRoute
  screensSignalsVolatileStocksScreenRoute: typeof screensSignalsVolatileStocksScreenRoute
  screensMutualFundsFundScreenRoute: typeof screensMutualFundsFundScreenRoute
  screensPortfolioAddWithMitraScreenRoute: typeof screensPortfolioAddWithMitraScreenRoute
  screensCoursesLectureScreenRoute: typeof screensCoursesLectureScreenRoute
  screensSignalsSignalStockScreenRoute: typeof screensSignalsSignalStockScreenRoute
  screensSignalsSignalTechnicalsScreenRoute: typeof screensSignalsSignalTechnicalsScreenRoute
}

const routesLayoutsAppRouteChildren: routesLayoutsAppRouteChildren = {
  screensAppHomeScreenRoute: screensAppHomeScreenRoute,
  screensAppAlertsScreenRoute: screensAppAlertsScreenRoute,
  screensBasketsBasketsScreenRoute: screensBasketsBasketsScreenRoute,
  screensBrokersOverviewScreenRoute: screensBrokersOverviewScreenRoute,
  screensAppChatScreenRoute: screensAppChatScreenRoute,
  screensAppCompaniesScreenRoute: screensAppCompaniesScreenRoute,
  screensCoursesCoursesScreenRoute: screensCoursesCoursesScreenRoute,
  screensDashboardsDashboardsScreenRoute:
    screensDashboardsDashboardsScreenRoute,
  screensIpoIssuesRedirectRoute: screensIpoIssuesRedirectRoute,
  screensMarketOverviewScreenRoute: screensMarketOverviewScreenRoute,
  screensMutualFundsAnalyticsScreenRoute:
    screensMutualFundsAnalyticsScreenRoute,
  screensNewsletterNewslettersRedirectRoute:
    screensNewsletterNewslettersRedirectRoute,
  screensAppNotificationsScreenRoute: screensAppNotificationsScreenRoute,
  screensPortfolioOverviewScreenRoute: screensPortfolioOverviewScreenRoute,
  screensAccountProfileScreenRoute: screensAccountProfileScreenRoute,
  screensScreenerScreenerRedirectRoute: screensScreenerScreenerRedirectRoute,
  screensAccountSettingsScreenRoute: screensAccountSettingsScreenRoute,
  screensAccountSubscriptionScreenRoute: screensAccountSubscriptionScreenRoute,
  screensAppWatchlistScreenRoute: screensAppWatchlistScreenRoute,
  screensBasketsBasketDetailScreenRoute: screensBasketsBasketDetailScreenRoute,
  screensBrokersBrokerScreenRoute: screensBrokersBrokerScreenRoute,
  screensBrokersAllBrokersScreenRoute: screensBrokersAllBrokersScreenRoute,
  screensBrokersByBrokerRedirectRoute: screensBrokersByBrokerRedirectRoute,
  screensBrokersByStockRedirectRoute: screensBrokersByStockRedirectRoute,
  screensBrokersCompareScreenRoute: screensBrokersCompareScreenRoute,
  screensBrokersLargeHoldingsScreenRoute:
    screensBrokersLargeHoldingsScreenRoute,
  screensBrokersLargeTradesScreenRoute: screensBrokersLargeTradesScreenRoute,
  screensBrokersLastMinuteScreenRoute: screensBrokersLastMinuteScreenRoute,
  screensBrokersMostTradedScreenRoute: screensBrokersMostTradedScreenRoute,
  screensBrokersPVRangeRedirectRoute: screensBrokersPVRangeRedirectRoute,
  screensBrokersReviewsRedirectRoute: screensBrokersReviewsRedirectRoute,
  screensBrokersSectorFlowScreenRoute: screensBrokersSectorFlowScreenRoute,
  screensCoursesCourseDetailScreenRoute: screensCoursesCourseDetailScreenRoute,
  screensCoursesCertificatesScreenRoute: screensCoursesCertificatesScreenRoute,
  screensCoursesFaqScreenRoute: screensCoursesFaqScreenRoute,
  screensCoursesMyLearningScreenRoute: screensCoursesMyLearningScreenRoute,
  screensCoursesLearningPathScreenRoute: screensCoursesLearningPathScreenRoute,
  screensDashboardsDashboardScreenRoute: screensDashboardsDashboardScreenRoute,
  screensDevComponentGalleryScreenRoute: screensDevComponentGalleryScreenRoute,
  screensIpoIpoScreenRoute: screensIpoIpoScreenRoute,
  screensCoursesDictionaryScreenRoute: screensCoursesDictionaryScreenRoute,
  screensMarketWeek52ScreenRoute: screensMarketWeek52ScreenRoute,
  screensMarketDepthScreenRoute: screensMarketDepthScreenRoute,
  screensMarketEventsScreenRoute: screensMarketEventsScreenRoute,
  screensMarketFloorsheetScreenRoute: screensMarketFloorsheetScreenRoute,
  screensMarketGainersLosersScreenRoute: screensMarketGainersLosersScreenRoute,
  screensMarketHeatmapScreenRoute: screensMarketHeatmapScreenRoute,
  screensMarketIndicesScreenRoute: screensMarketIndicesScreenRoute,
  screensIpoPublicIssuesScreenRoute: screensIpoPublicIssuesScreenRoute,
  screensMarketLiveMarketScreenRoute: screensMarketLiveMarketScreenRoute,
  screensMarketMoversScreenRoute: screensMarketMoversScreenRoute,
  screensMarketMarketNewsScreenRoute: screensMarketMarketNewsScreenRoute,
  screensNewsletterNewslettersScreenRoute:
    screensNewsletterNewslettersScreenRoute,
  screensMarketStockPricesRedirectRoute: screensMarketStockPricesRedirectRoute,
  screensMarketSectorsScreenRoute: screensMarketSectorsScreenRoute,
  screensSignalsSignalZoneScreenRoute: screensSignalsSignalZoneScreenRoute,
  screensMarketStockPricesScreenRoute: screensMarketStockPricesScreenRoute,
  screensMarketStockTradingScreenRoute: screensMarketStockTradingScreenRoute,
  screensMarketTradingAverageScreenRoute:
    screensMarketTradingAverageScreenRoute,
  screensMarketMarketUpdateScreenRoute: screensMarketMarketUpdateScreenRoute,
  screensMutualFundsDividendsScreenRoute:
    screensMutualFundsDividendsScreenRoute,
  screensMutualFundsIndustryHoldingsScreenRoute:
    screensMutualFundsIndustryHoldingsScreenRoute,
  screensMutualFundsMonthlyHoldingsRedirectRoute:
    screensMutualFundsMonthlyHoldingsRedirectRoute,
  screensMutualFundsPriceVsNavScreenRoute:
    screensMutualFundsPriceVsNavScreenRoute,
  screensMutualFundsRankingsScreenRoute: screensMutualFundsRankingsScreenRoute,
  screensNewsletterNewsletterIssueRedirectRoute:
    screensNewsletterNewsletterIssueRedirectRoute,
  screensAccountPaymentFailedScreenRoute:
    screensAccountPaymentFailedScreenRoute,
  screensAccountPaymentReturnScreenRoute:
    screensAccountPaymentReturnScreenRoute,
  screensPortfolioActivityScreenRoute: screensPortfolioActivityScreenRoute,
  screensPortfolioAllocationScreenRoute: screensPortfolioAllocationScreenRoute,
  screensPortfolioAnalyticsScreenRoute: screensPortfolioAnalyticsScreenRoute,
  screensPortfolioDashboardRedirectRoute:
    screensPortfolioDashboardRedirectRoute,
  screensPortfolioHealthScreenRoute: screensPortfolioHealthScreenRoute,
  screensPortfolioHoldingsScreenRoute: screensPortfolioHoldingsScreenRoute,
  screensPortfolioImportPortfolioScreenRoute:
    screensPortfolioImportPortfolioScreenRoute,
  screensPortfolioIncomeScreenRoute: screensPortfolioIncomeScreenRoute,
  screensPostsPostScreenRoute: screensPostsPostScreenRoute,
  screensScreenerAdvancedScreenerScreenRoute:
    screensScreenerAdvancedScreenerScreenRoute,
  screensStockStockScreenRoute: screensStockStockScreenRoute,
  screensAccountBillingHistoryScreenRoute:
    screensAccountBillingHistoryScreenRoute,
  screensAccountCheckoutScreenRoute: screensAccountCheckoutScreenRoute,
  screensAccountManagePlanScreenRoute: screensAccountManagePlanScreenRoute,
  screensBrokersBrokerReviewsScreenRoute:
    screensBrokersBrokerReviewsScreenRoute,
  screensBrokersByStockScreenRoute: screensBrokersByStockScreenRoute,
  screensBrokersPVRangeScreenRoute: screensBrokersPVRangeScreenRoute,
  screensCoursesCourseCheckoutScreenRoute:
    screensCoursesCourseCheckoutScreenRoute,
  screensCoursesPathStepScreenRoute: screensCoursesPathStepScreenRoute,
  screensCoursesDictionaryTermScreenRoute:
    screensCoursesDictionaryTermScreenRoute,
  screensMarketNewsArticleScreenRoute: screensMarketNewsArticleScreenRoute,
  screensNewsletterNewsletterIssueScreenRoute:
    screensNewsletterNewsletterIssueScreenRoute,
  screensSignalsBreakoutsScreenRoute: screensSignalsBreakoutsScreenRoute,
  screensSignalsCycleMapScreenRoute: screensSignalsCycleMapScreenRoute,
  screensSignalsDailyForecastScreenRoute:
    screensSignalsDailyForecastScreenRoute,
  screensSignalsEssentialsScreenRoute: screensSignalsEssentialsScreenRoute,
  screensSignalsSignalHistoryScreenRoute:
    screensSignalsSignalHistoryScreenRoute,
  screensSignalsLiveSignalsScreenRoute: screensSignalsLiveSignalsScreenRoute,
  screensSignalsOpenTradesScreenRoute: screensSignalsOpenTradesScreenRoute,
  screensSignalsTrendSignalsScreenRoute: screensSignalsTrendSignalsScreenRoute,
  screensSignalsVolatileStocksScreenRoute:
    screensSignalsVolatileStocksScreenRoute,
  screensMutualFundsFundScreenRoute: screensMutualFundsFundScreenRoute,
  screensPortfolioAddWithMitraScreenRoute:
    screensPortfolioAddWithMitraScreenRoute,
  screensCoursesLectureScreenRoute: screensCoursesLectureScreenRoute,
  screensSignalsSignalStockScreenRoute: screensSignalsSignalStockScreenRoute,
  screensSignalsSignalTechnicalsScreenRoute:
    screensSignalsSignalTechnicalsScreenRoute,
}

const routesLayoutsAppRouteWithChildren =
  routesLayoutsAppRoute._addFileChildren(routesLayoutsAppRouteChildren)

interface routesLayoutsAuthRouteChildren {
  screensAuthForgotPasswordScreenRoute: typeof screensAuthForgotPasswordScreenRoute
  screensAuthSignInScreenRoute: typeof screensAuthSignInScreenRoute
  screensAuthSignUpScreenRoute: typeof screensAuthSignUpScreenRoute
  screensAuthVerifyScreenRoute: typeof screensAuthVerifyScreenRoute
}

const routesLayoutsAuthRouteChildren: routesLayoutsAuthRouteChildren = {
  screensAuthForgotPasswordScreenRoute: screensAuthForgotPasswordScreenRoute,
  screensAuthSignInScreenRoute: screensAuthSignInScreenRoute,
  screensAuthSignUpScreenRoute: screensAuthSignUpScreenRoute,
  screensAuthVerifyScreenRoute: screensAuthVerifyScreenRoute,
}

const routesLayoutsAuthRouteWithChildren =
  routesLayoutsAuthRoute._addFileChildren(routesLayoutsAuthRouteChildren)

interface routesLayoutsPublicRouteChildren {
  screensCoursesVerifyCertificateScreenRoute: typeof screensCoursesVerifyCertificateScreenRoute
}

const routesLayoutsPublicRouteChildren: routesLayoutsPublicRouteChildren = {
  screensCoursesVerifyCertificateScreenRoute:
    screensCoursesVerifyCertificateScreenRoute,
}

const routesLayoutsPublicRouteWithChildren =
  routesLayoutsPublicRoute._addFileChildren(routesLayoutsPublicRouteChildren)

interface routesLayoutsWorkspaceRouteChildren {
  screensChartChartRedirectRoute: typeof screensChartChartRedirectRoute
  screensChartChartScreenRoute: typeof screensChartChartScreenRoute
}

const routesLayoutsWorkspaceRouteChildren: routesLayoutsWorkspaceRouteChildren =
  {
    screensChartChartRedirectRoute: screensChartChartRedirectRoute,
    screensChartChartScreenRoute: screensChartChartScreenRoute,
  }

const routesLayoutsWorkspaceRouteWithChildren =
  routesLayoutsWorkspaceRoute._addFileChildren(
    routesLayoutsWorkspaceRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  routesLayoutsAppRoute: routesLayoutsAppRouteWithChildren,
  routesLayoutsAuthRoute: routesLayoutsAuthRouteWithChildren,
  routesLayoutsPublicRoute: routesLayoutsPublicRouteWithChildren,
  routesLayoutsWorkspaceRoute: routesLayoutsWorkspaceRouteWithChildren,
  screensOnboardingWelcomeScreenRoute: screensOnboardingWelcomeScreenRoute,
  screensOnboardingAllDoneScreenRoute: screensOnboardingAllDoneScreenRoute,
  screensOnboardingWhosClosestScreenRoute:
    screensOnboardingWhosClosestScreenRoute,
  screensOnboardingPickPlanScreenRoute: screensOnboardingPickPlanScreenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
